!function(e){function n(n){for(var t,o,i=n[0],u=n[1],a=0,l=[];a<i.length;a++)o=i[a],Object.prototype.hasOwnProperty.call(r,o)&&r[o]&&l.push(r[o][0]),r[o]=0;for(t in u)Object.prototype.hasOwnProperty.call(u,t)&&(e[t]=u[t]);for(c&&c(n);l.length;)l.shift()()}var t={},r={1:0};function o(n){if(t[n])return t[n].exports;var r=t[n]={i:n,l:!1,exports:{}};return e[n].call(r.exports,r,r.exports,o),r.l=!0,r.exports}o.e=function(e){var n=[],t=r[e];if(0!==t)if(t)n.push(t[2]);else{var i=new Promise((function(n,o){t=r[e]=[n,o]}));n.push(t[2]=i);var u,a=document.createElement("script");a.charset="utf-8",a.timeout=120,o.nc&&a.setAttribute("nonce",o.nc),a.src=function(e){return o.p+"npm-deps."+({0:"lazyLoadAppInsight",2:"vendors~lazyLoadAppInsight"}[e]||e)+".2020-11-24~10.js"}(e);var c=new Error;u=function(n){a.onerror=a.onload=null,clearTimeout(l);var t=r[e];if(0!==t){if(t){var o=n&&("load"===n.type?"missing":n.type),i=n&&n.target&&n.target.src;c.message="Loading chunk "+e+" failed.\n("+o+": "+i+")",c.name="ChunkLoadError",c.type=o,c.request=i,t[1](c)}r[e]=void 0}};var l=setTimeout((function(){u({type:"timeout",target:a})}),12e4);a.onerror=a.onload=u,document.head.appendChild(a)}return Promise.all(n)},o.m=e,o.c=t,o.d=function(e,n,t){o.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:t})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,n){if(1&n&&(e=o(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var t=Object.create(null);if(o.r(t),Object.defineProperty(t,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)o.d(t,r,function(n){return e[n]}.bind(null,r));return t},o.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(n,"a",n),n},o.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},o.p="/includes/scripts/",o.oe=function(e){throw console.error(e),e};var i=window.webpackJsonp=window.webpackJsonp||[],u=i.push.bind(i);i.push=n,i=i.slice();for(var a=0;a<i.length;a++)n(i[a]);var c=u;o(o.s=1)}([function(e,n,t){"use strict";var r;t.d(n,"b",(function(){return u})),t.d(n,"a",(function(){return a})),t.d(n,"d",(function(){return c})),t.d(n,"c",(function(){return l}));var o,i=!1;function u(e){o=e}window.aILogException=function(e){r?r.trackException(e):f(e)};var a=function(e,n){var t={};if(0===n)return{};for(var r in e)if(e.hasOwnProperty(r))if("object"!=typeof e[r]||null===e[r]||e[r]instanceof Date)t[r]=e[r];else{var o=a(e[r],n-1);for(var i in o)o.hasOwnProperty(i)&&null!=o[i]&&""!==o[i]&&(t[r+"."+i]=o[i])}return t},c=function(e){return["Script error","ResizeObserver loop limit exceeded","Unexpected EOF","null is not an object (evaluating","Can't find variable: ga","Cannot read property 'getReadMode","Illegal invocation"].some((function(n){return-1!==(null==e?void 0:e.indexOf(n))}))},l=function(e){return["stats.g.doubleclick.net","www.google-analytics.com"].some((function(n){return-1!==(null==e?void 0:e.indexOf(n))}))},s=function(){for(var e,n=[],t=0;t<arguments.length;t++)n[t]=arguments[t];if((null==n?void 0:n.length)&&!c(n[0].message)){var o=n[0],u={exception:"[object Error]"===Object.prototype.toString.call(o)?o:"[object Error]"===Object.prototype.toString.call(o.error)?o.error:o.message||(null===(e=o.target)||void 0===e?void 0:e.outerHTML)||o.error||o,properties:a(n,6)};r?(window.removeEventListener("error",s,!0),r.trackException(u)):i?setTimeout((function(){window.removeEventListener("error",s,!0),null==r||r.trackException(u)}),2e3):f(u)}};window.addEventListener("error",s,!0);var f=function(e){i||(i=!0,["localhost","127.0.0.1","","[::1]"].some((function(e){var n;return e===(null===(n=null===window||void 0===window?void 0:window.location)||void 0===n?void 0:n.hostname)}))||Promise.all([t.e(2),t.e(0)]).then(t.bind(null,2)).then((function(n){(r=n.initAppInsight(o))&&e&&r.trackException(e)})))};setTimeout((function(){f(null)}),1e4)},function(e,n,t){"use strict";t.r(n);var r=t(0);Object(r.b)({config:{instrumentationKey:"fb8ee315-190a-402c-b44d-3374587b809e"}})}]); $(document).ready(function () {
  modalSetup(document);

  // When the user clicks anywhere outside of the modal, close it - unless it's a holiday price modal on CLG
  window.onclick = function (event) {
    if (
      $(event.target).hasClass("modal") &&
      !$(event.target).hasClass("holidayPriceModal") &&
      !$(event.target).hasClass("bookingFormModal")
    ) {
      closeModal($(event.target));
    }
  };

  // Listen for keydown event to close the modal when the Escape key is pressed
  $(document).keydown(function (event) {
    if (event.keyCode === 27) {
      // 27 is the code for the Escape key
      var openModal = $(".modal:visible"); // This will select the currently open modal if any
      closeModal(openModal);
    }
  });
});

function modalSetup(startingElement) {
  // When the user clicks on <span> (x), close the modal
  $(startingElement)
    .find(".modalClose")
    .click(function () {
      closeModal($(this).closest(".modal"));
    });
}

function closeModal(modal) {
  //raise closing event
  $(modal).trigger("closingmodal");

  // Remove the .active class from everything inside the modal
  $(modal).find(".active").removeClass("active");

  // Set the display style to "none" for .toggle_container elements
  $(modal).find(".toggle_container").css("display", "none");

  // Close the modal with a fade out effect
  $(modal).fadeOut();
}

function openModal(modalID, GATrackingType, trigger) {
  $("#" + modalID)
    .fadeIn()
    .css("display", "grid");

  // Check if trigger exists and adjust the modal padding accordingly
  if (trigger && $(trigger).closest(".iframe").length > 0) {
    var offsetVal = $(trigger).offset().top - 300;
    offsetVal = Math.max(20, offsetVal);
    $("#" + modalID).css("padding-top", offsetVal);
  }
}

// Display message in a modal
function displayMessageInModal(HTMLToDisplay) {
  // Remove old message modals
  $("#tempMessageModal").remove();

  var modalHTML =
    '<div id="tempMessageModal" class="modal"><div class="modalContent"><span class="modalClose" onclick="closeModal($(this).closest(\'.modal\'))">&times;</span>';
  modalHTML += HTMLToDisplay;
  modalHTML += "</div></div>";

  $("body").append(modalHTML);
  openModal("tempMessageModal");
}
 /*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }

}(function($) {
    'use strict';
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '5%',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 10,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active').attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div aria-live="polite" class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 1) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).off('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 1) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }


        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }

        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $(this).attr('style', $(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick',
                '*:not(.slick-arrow)', function(event) {

            event.stopImmediatePropagation();
            var $sf = $(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                verticalOffset = (verticalHeight * _.options.slidesToShow) * -1;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this;
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        _.$slideTrack.attr('role', 'listbox');

        _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
            $(this).attr({
                'role': 'option',
                'aria-describedby': 'slick-slide' + _.instanceUid + i + ''
            });
        });

        if (_.$dots !== null) {
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                $(this).attr({
                    'role': 'presentation',
                    'aria-selected': 'false',
                    'aria-controls': 'navigation' + _.instanceUid + i + '',
                    'id': 'slick-slide' + _.instanceUid + i + ''
                });
            })
                .first().attr('aria-selected', 'true').end()
                .find('button').attr('role', 'button').end()
                .closest('div').attr('role', 'toolbar');
        }
        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
        }

        if ( _.options.dots === true && _.options.pauseOnDotsHover === true ) {

            $('li', _.$dots)
                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(document).on('ready.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function() {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {
                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            _.setPosition();

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;
                currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {

                    _.$slides
                        .slice(index - centerOffset, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand') {
            _.lazyLoad();
        }

    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $(event.target).is('.slick-slide') ?
                $(event.target) :
                $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.setSlideClasses(index);
            _.asNavFor(index);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            edgeWasHit = false,
            curLeft, swipeDirection, swipeLength, positionOffset, touches;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = Math.round(Math.sqrt(
                Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        }

        swipeDirection = _.swipeDirection();

        if (swipeDirection === 'vertical') {
            return;
        }

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                .removeClass('slick-active')
                .attr('aria-hidden', 'true');

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active')
                .attr('aria-hidden', 'false');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].slick = new Slick(_[i], opt);
            else
                ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };

}));
 $(document).ready(function () {
  $(".sliderStyleFourItems .slider")
    .not(".slick-initialized")
    .slick({
      centerMode: true,
      swipeToSlide: true,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4.3,
      slidesToScroll: 4,
      initialSlide: 2, // sets the first slide, is zero indexed

      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3.3,
            slidesToScroll: 3,
            speed: 500,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2.3,
            slidesToScroll: 2,
            speed: 500,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            speed: 500,
            initialSlide: 0.8,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

  $(".sliderStyleThreeItems .slider")
    .not(".slick-initialized")
    .slick({
      centerMode: true,
      swipeToSlide: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3.3,
      slidesToScroll: 3,
      initialSlide: 1,

      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2.2,
            slidesToScroll: 1,
            speed: 500,
            initialSlide: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            speed: 500,
            initialSlide: 0,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

  // The below was added by Dan for cases where children need to be wider, e.g. they contain columns
  // Regular sliderStyleTwoItems is below. Keep them in this order or it won't work.

  $(
    ".sliderStyleTwoItems.promotedContentWrapper .slider, .sliderStyleTwoItems.specialOffersWrapper .slider"
  )
    .not(".slick-initialized")
    .slick({
      centerMode: true,
      swipeToSlide: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2.3,
      slidesToScroll: 1,
      initialSlide: 2,

      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1.12,
            slidesToScroll: 1,
            speed: 500,
            initialSlide: 1,
          },
        },
      ],
    });

  $(".sliderStyleTwoItems .slider")
    .not(".slick-initialized")
    .slick({
      centerMode: true,
      swipeToSlide: true,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2.3,
      slidesToScroll: 1,
      initialSlide: 2,

      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            initialSlide: 1,
          },
        },
      ],
    });

  $(".sliderStyleOneItem .slider").not(".slick-initialized").slick({
    centerMode: true,
    dots: true,
    infinite: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  });

  $(".reviewSlider .slider").not(".slick-initialized").slick({
    centerMode: false,
    dots: false,
    infinite: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  });

  $(
    ".sliderGalleryWithThumbnails .sliderWrapper.sliderStyleFullWidthSlide .slider"
  )
    .not(".slick-initialized")
    .slick({
      centerMode: false,
      dots: false,
      infinite: true,
      speed: 750,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
    });

  $(".sliderStyleFullWidthSlide .slider").not(".slick-initialized").slick({
    centerMode: false,
    dots: true,
    infinite: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  });

  // For use where one slider controls the display of another (e.g. thumbnail and main image)
  $(".slider-for").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,

    dots: false,
    fade: true,
    asNavFor: ".slider-nav",
  });

  $(".slider-nav").not(".slick-initialized").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: ".slider-for",
    dots: false,
    centerMode: true,
    focusOnSelect: true,
  });

  //setup variable options

  $(".slider").each(function () {
    if ($(this).hasClass("slickAutoPlay5000")) {
      $(this).slick("slickSetOption", "autoplay", true, true);
      $(this).slick("slickSetOption", "autoplaySpeed", 5000, true);
    }

    if ($(this).hasClass("slickAutoPlay2500")) {
      $(this).slick("slickSetOption", "autoplay", true, true);
      $(this).slick("slickSetOption", "autoplaySpeed", 2500, true);
    }

    if ($(this).hasClass("slickFade")) {
      $(this).slick("slickSetOption", "fade", true, true);
      $(this).slick("slickSetOption", "speed", 2500, true);
      $(this).slick("slickSetOption", "infinite", true, true);
    }

    if ($(this).hasClass("slickHideDots")) {
      $(this).slick("slickSetOption", "dots", false, true);
    }

    if ($(this).hasClass("slickHideArrows")) {
      $(this).slick("slickSetOption", "arrows", false, true);
    }
  });
});
 /*! lazysizes - v5.1.2 */
!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}("undefined"!=typeof window?window:{},function(a,b){"use strict";var c,d;if(function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:0,throttleDelay:125};d=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in d||(d[b]=c[b])}(),!b||!b.getElementsByClassName)return{init:function(){},cfg:d,noSupport:!0};var e=b.documentElement,f=a.Date,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h],k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,d,e,f,g){var h=b.createEvent("Event");return e||(e={}),e.instance=c,h.initEvent(d,!f,!g),h.detail=e,a.dispatchEvent(h),h},w=function(b,c){var e;!g&&(e=a.picturefill||d.pf)?(c&&c.src&&!b[i]("srcset")&&b.setAttribute("srcset",c.src),e({reevaluate:!0,elements:[b]})):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<d.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,c=0,e=d.throttleDelay,g=d.ricTimeout,h=function(){b=!1,c=f.now(),a()},i=m&&g>49?function(){m(h,{timeout:g}),g!==d.ricTimeout&&(g=d.ricTimeout)}:A(function(){k(h)},!0);return function(a){var d;(a=!0===a)&&(g=33),b||(b=!0,d=e-(f.now()-c),d<0&&(d=0),a||d<9?i():k(i,d))}},C=function(a){var b,c,d=99,e=function(){b=null,a()},g=function(){var a=f.now()-c;a<d?k(g,d-a):(m||e)(e)};return function(){c=f.now(),b||(b=k(g,d))}},D=function(){var g,l,m,o,p,y,D,F,G,H,I,J,K=/^img$/i,L=/^iframe$/i,M="onscroll"in a&&!/(gle|ing)bot/.test(navigator.userAgent),N=0,O=0,P=0,Q=-1,R=function(a){P--,(!a||P<0||!a.target)&&(P=0)},S=function(a){return null==J&&(J="hidden"==x(b.body,"visibility")),J||!("hidden"==x(a.parentNode,"visibility")&&"hidden"==x(a,"visibility"))},T=function(a,c){var d,f=a,g=S(a);for(F-=c,I+=c,G-=c,H+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=e;)(g=(x(f,"opacity")||1)>0)&&"visible"!=x(f,"overflow")&&(d=f.getBoundingClientRect(),g=H>d.left&&G<d.right&&I>d.top-1&&F<d.bottom+1);return g},U=function(){var a,f,h,j,k,m,n,p,q,r,s,t,u=c.elements;if((o=d.loadMode)&&P<8&&(a=u.length)){for(f=0,Q++;f<a;f++)if(u[f]&&!u[f]._lazyRace)if(!M||c.prematureUnveil&&c.prematureUnveil(u[f]))aa(u[f]);else if((p=u[f][i]("data-expand"))&&(m=1*p)||(m=O),r||(r=!d.expand||d.expand<1?e.clientHeight>500&&e.clientWidth>500?500:370:d.expand,c._defEx=r,s=r*d.expFactor,t=d.hFac,J=null,O<s&&P<1&&Q>2&&o>2&&!b.hidden?(O=s,Q=0):O=o>1&&Q>1&&P<6?r:N),q!==m&&(y=innerWidth+m*t,D=innerHeight+m,n=-1*m,q=m),h=u[f].getBoundingClientRect(),(I=h.bottom)>=n&&(F=h.top)<=D&&(H=h.right)>=n*t&&(G=h.left)<=y&&(I||H||G||F)&&(d.loadHidden||S(u[f]))&&(l&&P<3&&!p&&(o<3||Q<4)||T(u[f],m))){if(aa(u[f]),k=!0,P>9)break}else!k&&l&&!j&&P<4&&Q<4&&o>2&&(g[0]||d.preloadAfterLoad)&&(g[0]||!p&&(I||H||G||F||"auto"!=u[f][i](d.sizesAttr)))&&(j=g[0]||u[f]);j&&!k&&aa(j)}},V=B(U),W=function(a){var b=a.target;if(b._lazyCache)return void delete b._lazyCache;R(a),s(b,d.loadedClass),t(b,d.loadingClass),u(b,Y),v(b,"lazyloaded")},X=A(W),Y=function(a){X({target:a.target})},Z=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},$=function(a){var b,c=a[i](d.srcsetAttr);(b=d.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},_=A(function(a,b,c,e,f){var g,h,j,l,o,p;(o=v(a,"lazybeforeunveil",b)).defaultPrevented||(e&&(c?s(a,d.autosizesClass):a.setAttribute("sizes",e)),h=a[i](d.srcsetAttr),g=a[i](d.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),o={target:a},s(a,d.loadingClass),p&&(clearTimeout(m),m=k(R,2500),u(a,Y,!0)),l&&q.call(j.getElementsByTagName("source"),$),h?a.setAttribute("srcset",h):g&&!l&&(L.test(a.nodeName)?Z(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,d.lazyClass),z(function(){var b=a.complete&&a.naturalWidth>1;p&&!b||(b&&s(a,"ls-is-cached"),W(o),a._lazyCache=!0,k(function(){"_lazyCache"in a&&delete a._lazyCache},9)),"lazy"==a.loading&&P--},!0)}),aa=function(a){if(!a._lazyRace){var b,c=K.test(a.nodeName),e=c&&(a[i](d.sizesAttr)||a[i]("sizes")),f="auto"==e;(!f&&l||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,d.errorClass)||!r(a,d.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,P++,_(a,b,f,e,c))}},ba=C(function(){d.loadMode=3,V()}),ca=function(){3==d.loadMode&&(d.loadMode=2),ba()},da=function(){if(!l){if(f.now()-p<999)return void k(da,999);l=!0,d.loadMode=3,V(),j("scroll",ca,!0)}};return{_:function(){p=f.now(),c.elements=b.getElementsByClassName(d.lazyClass),g=b.getElementsByClassName(d.lazyClass+" "+d.preloadClass),j("scroll",V,!0),j("resize",V,!0),a.MutationObserver?new MutationObserver(V).observe(e,{childList:!0,subtree:!0,attributes:!0}):(e[h]("DOMNodeInserted",V,!0),e[h]("DOMAttrModified",V,!0),setInterval(V,999)),j("hashchange",V,!0),["focus","mouseover","click","load","transitionend","animationend"].forEach(function(a){b[h](a,V,!0)}),/d$|^c/.test(b.readyState)?da():(j("load",da),b[h]("DOMContentLoaded",V),k(da,2e4)),c.elements.length?(U(),z._lsFlush()):V()},checkElems:V,unveil:aa,_aLSL:ca}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;f<g;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),e=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width)&&d!==a._lazysizesWidth&&c(a,f,e,d))},f=function(){var b,c=a.length;if(c)for(b=0;b<c;b++)e(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(d.autosizesClass),j("resize",g)},checkElems:g,updateElem:e}}(),F=function(){!F.i&&b.getElementsByClassName&&(F.i=!0,E._(),D._())};return k(function(){d.init&&F()}),c={cfg:d,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}}); /**
 * Centralized reCAPTCHA Manager for The Ski Gathering
 * 
 * Manages multiple reCAPTCHA v2 widgets across the site, supporting:
 * - Multiple forms per page (contact + newsletter, booking + callback, etc.)
 * - Multiple identical forms on same page (true multi-instance support)
 * - Multi-language support (EN/FR) with automatic language detection
 * - Explicit widget rendering with unique IDs
 * - Dynamic API script injection (no head.php dependency)
 * - Single API script load with render=explicit
 * - Widget registry for form-specific validation
 * - Automatic validation UI management (success/expired states)
 * - Debug mode for troubleshooting
 * 
 * Setup:
 *   1. Include this script in TSG bundle (loads before tsg-contact.js)
 *   2. Add data-sitekey and optional data-language to each reCAPTCHA container:
 *      <div id="recaptcha-contact-form" 
 *           data-sitekey="<?php echo $siteKey; ?>"
 *           data-language="en"></div>
 *   3. Optionally wrap container in element with .error-message sibling for automatic error display
 *   4. API script loads automatically when widgets are detected (no head.php script needed)
 * 
 * Language Detection (priority order):
 *   1. data-language attribute on container
 *   2. data-language attribute on parent form
 *   3. form_language hidden input in parent form
 *   4. URL path contains /fr/
 *   5. Default to 'en'
 * 
 * Usage:
 *   // Auto-registration happens automatically via data-sitekey scanning
 *   // Success/expired callbacks wire up automatically
 *   
 *   // Get response token for server-side validation
 *   const token = window.RecaptchaManager.getResponse('recaptcha-contact-form');
 * 
 *   // Check if widget is completed (client-side only, always verify server-side)
 *   const isComplete = window.RecaptchaManager.isCompleted('recaptcha-contact-form');
 * 
 * @version 2.1.0-tsg
 * @date 2025-12-05
 * @site The Ski Gathering
 * 
 * Changelog:
 *   2.1.0-tsg (2025-12-05): Added BFCache recovery handler for back-navigation
 *   2.1.0-tsg (2025-06-20): Initial TSG version with multi-instance support
 */

(function() {
    'use strict';

    // Widget registry: { containerId: { widgetId, containerId, callback, rendered, language } }
    const widgetRegistry = {};
    
    // Track if API script has been injected
    let apiInjected = false;
    
    // API ready state
    let apiLoaded = false;
    let apiLoadCallbacks = [];
    
    // Debug mode (enable via console: window.RecaptchaManager.enableDebug())
    let debugMode = false;

    /**
     * Log debug messages when debug mode is enabled
     */
    function debug(...args) {
        if (debugMode) {
            console.log('[RecaptchaManager]', ...args);
        }
    }

    /**
     * Detect language for a reCAPTCHA container
     * Priority: container data-language > form data-language > form_language input > URL path > default 'en'
     */
    function detectLanguage(container) {
        // Priority 1: Check data-language attribute on container itself
        if (container.getAttribute('data-language')) {
            return container.getAttribute('data-language');
        }
        
        // Priority 2: Check data-language attribute on parent form
        const form = container.closest('form');
        if (form && form.getAttribute('data-language')) {
            return form.getAttribute('data-language');
        }
        
        // Priority 3: Check for form_language hidden input
        if (form) {
            const languageInput = form.querySelector('input[name="form_language"]');
            if (languageInput && languageInput.value) {
                return languageInput.value;
            }
        }
        
        // Priority 4: Check URL path for /fr/
        if (window.location.pathname.includes('/fr/')) {
            return 'fr';
        }
        
        // Priority 5: Default to English
        return 'en';
    }

    /**
     * Dynamically inject the reCAPTCHA API script
     * Only injects once; subsequent calls are no-ops
     * 
     * Benefits:
     * - Zero external dependencies (no head.php script needed)
     * - Eliminates BFCache/race condition issues
     * - Loads only when reCAPTCHA widgets exist on the page
     */
    function injectApiScript() {
        // Only inject once
        if (apiInjected) {
            debug('API script already injected, skipping');
            return;
        }
        
        // Check if script already exists (defensive)
        if (document.querySelector('script[src*="recaptcha/api.js"]')) {
            debug('API script already in DOM, skipping injection');
            apiInjected = true;
            return;
        }
        
        debug('Injecting reCAPTCHA API script...');
        apiInjected = true;
        
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?onload=recaptchaManagerInit&render=explicit';
        script.async = true;
        script.defer = true;
        
        script.onerror = function() {
            console.error('[RecaptchaManager] Failed to load reCAPTCHA API script');
            apiInjected = false; // Allow retry
        };
        
        document.head.appendChild(script);
        debug('API script injected');
    }

    /**
     * Auto-register all reCAPTCHA widgets found in the DOM
     * Scans for any element with data-sitekey attribute and registers it
     */
    function autoRegisterWidgets() {
        debug('Auto-registering widgets...');
        
        // Check if any widgets exist before injecting script
        const containers = document.querySelectorAll('[data-sitekey]');
        if (containers.length > 0) {
            injectApiScript();
        } else {
            debug('No reCAPTCHA widgets found, skipping API load');
            return 0;
        }
        
        let registeredCount = 0;
        
        containers.forEach(function(container) {
            const containerId = container.id;
            if (!containerId) {
                console.warn('[RecaptchaManager] Skipping container without ID:', container);
                return;
            }
            
            // Skip if already registered (use container ID as unique key)
            if (widgetRegistry[containerId]) {
                debug('Widget already registered, skipping:', containerId);
                return;
            }
            
            // Detect language for this widget
            const language = detectLanguage(container);
            
            // Register the widget WITH default success callback
            // Use container ID as registry key for true uniqueness
            debug('Auto-registering:', containerId, 'language:', language);
            widgetRegistry[containerId] = {
                containerId: containerId,
                language: language,
                callback: function() {
                    // Success: user completed reCAPTCHA, clear validation errors
                    onWidgetSuccess(containerId);
                },
                widgetId: null,
                rendered: false
            };
            
            registeredCount++;
        });
        
        debug('Auto-registered', registeredCount, 'widget(s)');
        return registeredCount;
    }

    /**
     * Called by Google reCAPTCHA API when ready
     * This function name must match the onload parameter in the API script URL
     */
    window.recaptchaManagerInit = function() {
        apiLoaded = true;
        debug('reCAPTCHA API loaded');
        
        // Execute any queued callbacks FIRST (they may register widgets)
        const callbacks = apiLoadCallbacks.slice(); // Copy array
        apiLoadCallbacks = [];
        callbacks.forEach(cb => {
            try {
                cb();
            } catch (e) {
                console.error('[RecaptchaManager] Error in API ready callback:', e);
            }
        });
        
        // Auto-register any widgets found in the DOM
        autoRegisterWidgets();
        
        // NOW render all registered widgets (manual + auto-registered)
        Object.keys(widgetRegistry).forEach(containerId => {
            const widget = widgetRegistry[containerId];
            if (!widget.rendered) {
                renderWidget(containerId);
            }
        });
        
        debug('Rendered', Object.keys(widgetRegistry).length, 'widget(s)');
    };
    
    // Auto-scan for widgets when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            autoRegisterWidgets();
        });
    } else {
        // DOM already loaded (script loaded defer/async or at bottom)
        autoRegisterWidgets();
    }

    // Timeout check: warn if API doesn't load within 10 seconds (only if widgets found)
    setTimeout(function() {
        if (apiInjected && !apiLoaded) {
            console.warn('[RecaptchaManager] API not loaded after 10 seconds. Check network tab for api.js script.');
            console.warn('[RecaptchaManager] Registered widgets:', Object.keys(widgetRegistry));
        }
    }, 10000);

    /**
     * BFCache Recovery Handler (v2.1.0)
     * When user navigates back via BFCache, reCAPTCHA widgets may be in broken state.
     * This re-renders all widgets to ensure they work correctly.
     */
    window.addEventListener('pageshow', function(event) {
        if (event.persisted) {
            debug('BFCache restore detected, re-rendering widgets...');
            
            // Re-render all widgets that were previously rendered
            Object.keys(widgetRegistry).forEach(function(containerId) {
                var widget = widgetRegistry[containerId];
                if (widget.rendered) {
                    var container = document.getElementById(containerId);
                    if (container) {
                        // Clear the container and reset state
                        container.innerHTML = '';
                        widget.rendered = false;
                        widget.widgetId = null;
                        
                        // Re-render the widget
                        renderWidget(containerId);
                    }
                }
            });
            
            debug('BFCache recovery complete');
        }
    });

    /**
     * Execute callback when reCAPTCHA API is ready
     */
    function ready(callback) {
        if (apiLoaded && typeof grecaptcha !== 'undefined') {
            callback();
        } else {
            apiLoadCallbacks.push(callback);
        }
    }

    /**
     * Called when user successfully completes reCAPTCHA
     * Clears validation errors and messages
     */
    function onWidgetSuccess(containerId) {
        debug('reCAPTCHA completed for widget:', containerId);
        
        const widget = widgetRegistry[containerId];
        if (!widget) {
            return;
        }

        const container = document.getElementById(widget.containerId);
        if (!container) {
            return;
        }

        // Clear validation error styling (TSG uses has-error and inputError)
        container.classList.remove('has-error');
        container.classList.remove('inputError'); // TSG legacy class
        container.classList.remove('validation-error'); // CommonLibraries compatibility
        
        // Clear error message if present
        // TSG uses .tsg-be-error and .error-message patterns
        const errorMessage = container.parentElement.querySelector('.tsg-be-error, .error-message');
        if (errorMessage) {
            errorMessage.style.display = 'none';
            errorMessage.textContent = '';
        }

        debug('Cleared validation errors for:', containerId);
    }

    /**
     * Called when reCAPTCHA token expires (120 seconds after completion)
     * Marks widget as invalid again
     */
    function onWidgetExpired(containerId) {
        debug('reCAPTCHA expired for widget:', containerId);
        
        const widget = widgetRegistry[containerId];
        if (!widget) {
            return;
        }

        const container = document.getElementById(widget.containerId);
        if (!container) {
            return;
        }

        // Add validation error styling (expired = invalid)
        container.classList.add('has-error');
        container.classList.add('inputError'); // TSG legacy class
        container.classList.add('validation-error'); // CommonLibraries compatibility
        
        // Show error message if container exists
        const errorMessage = container.parentElement.querySelector('.tsg-be-error, .error-message');
        if (errorMessage) {
            errorMessage.style.display = 'block';
            // Use language-appropriate expiry message
            const expiryMessage = widget.language === 'fr' 
                ? 'reCAPTCHA expiré. Veuillez vérifier à nouveau.'
                : 'reCAPTCHA expired. Please verify again.';
            errorMessage.textContent = expiryMessage;
        }

        debug('Marked widget as expired:', containerId);
    }

    /**
     * Render a widget that was previously registered
     */
    function renderWidget(containerId) {
        const widget = widgetRegistry[containerId];
        if (!widget) {
            console.error('[RecaptchaManager] Cannot render: widget not registered:', containerId);
            return;
        }

        if (widget.rendered) {
            debug('Widget already rendered:', containerId);
            return;
        }

        const container = document.getElementById(widget.containerId);
        if (!container) {
            console.error('[RecaptchaManager] Container not found:', widget.containerId);
            return;
        }

        if (typeof grecaptcha === 'undefined') {
            console.error('[RecaptchaManager] grecaptcha not loaded');
            return;
        }

        try {
            // Get site key from container data attribute
            const siteKey = container.getAttribute('data-sitekey');
            if (!siteKey) {
                console.error('[RecaptchaManager] No site key on container:', widget.containerId);
                return;
            }

            const config = {
                sitekey: siteKey,
                hl: widget.language // Set reCAPTCHA language
            };

            // Add success callback (always present - either custom or default)
            if (widget.callback) {
                config.callback = widget.callback;
            }

            // Add expired callback (marks widget as invalid when token expires)
            config['expired-callback'] = function() {
                onWidgetExpired(containerId);
            };

            widget.widgetId = grecaptcha.render(widget.containerId, config);
            widget.rendered = true;
            debug('Rendered widget:', containerId, 'language:', widget.language, 'widgetId:', widget.widgetId);
        } catch (e) {
            console.error('[RecaptchaManager] Failed to render widget:', containerId, e);
        }
    }

    /**
     * Register a reCAPTCHA widget manually
     * 
     * @param {string} containerId - ID of the div where reCAPTCHA will render (used as unique key)
     * @param {function} callback - Optional callback when reCAPTCHA is completed
     * @param {string} language - Optional language override (defaults to auto-detection)
     */
    function registerWidget(containerId, callback, language) {
        debug('Manually registering widget:', containerId);

        if (widgetRegistry[containerId]) {
            console.warn('[RecaptchaManager] Widget already registered:', containerId, '- replacing');
        }

        const container = document.getElementById(containerId);
        const detectedLanguage = language || (container ? detectLanguage(container) : 'en');

        widgetRegistry[containerId] = {
            containerId: containerId,
            language: detectedLanguage,
            callback: callback || null,
            widgetId: null,
            rendered: false
        };

        // If API already loaded, render immediately
        if (apiLoaded && typeof grecaptcha !== 'undefined') {
            debug('API already loaded, rendering immediately:', containerId);
            renderWidget(containerId);
        } else {
            debug('API not loaded yet, widget will render when API ready:', containerId);
        }
    }

    /**
     * Get the reCAPTCHA response token for a specific widget
     * 
     * @param {string} containerId - Container ID of the reCAPTCHA widget
     * @returns {string} - reCAPTCHA response token, or empty string if not completed
     */
    function getResponse(containerId) {
        const widget = widgetRegistry[containerId];
        if (!widget) {
            console.error('[RecaptchaManager] Widget not registered:', containerId);
            return '';
        }

        if (!widget.rendered || widget.widgetId === null) {
            debug('Widget not rendered yet:', containerId);
            return '';
        }

        if (typeof grecaptcha === 'undefined') {
            console.error('[RecaptchaManager] grecaptcha not loaded');
            return '';
        }

        try {
            const response = grecaptcha.getResponse(widget.widgetId);
            debug('getResponse for', containerId, ':', response ? 'token present' : 'empty');
            return response || '';
        } catch (e) {
            console.error('[RecaptchaManager] Error getting response for', containerId, ':', e);
            return '';
        }
    }

    /**
     * Check if a widget has been completed
     * 
     * @param {string} containerId - Container ID of the reCAPTCHA widget
     * @returns {boolean} - True if widget completed
     */
    function isCompleted(containerId) {
        const response = getResponse(containerId);
        return response.trim() !== '';
    }

    /**
     * Reset a widget (clears the checkbox)
     * 
     * @param {string} containerId - Container ID of the reCAPTCHA widget
     */
    function reset(containerId) {
        const widget = widgetRegistry[containerId];
        if (!widget || !widget.rendered || widget.widgetId === null) {
            debug('Cannot reset widget:', containerId, '- not rendered');
            return;
        }

        if (typeof grecaptcha === 'undefined') {
            console.error('[RecaptchaManager] grecaptcha not loaded');
            return;
        }

        try {
            grecaptcha.reset(widget.widgetId);
            debug('Reset widget:', containerId);
        } catch (e) {
            console.error('[RecaptchaManager] Error resetting widget:', containerId, e);
        }
    }

    /**
     * Debug: Log all registered widgets and their states
     */
    function debugDump() {
        console.log('[RecaptchaManager] Debug dump:');
        console.log('API loaded:', apiLoaded);
        console.log('grecaptcha available:', typeof grecaptcha !== 'undefined');
        console.log('Registered widgets:', Object.keys(widgetRegistry).length);
        
        Object.keys(widgetRegistry).forEach(containerId => {
            const widget = widgetRegistry[containerId];
            const response = widget.rendered ? getResponse(containerId) : 'not rendered';
            console.log(`  ${containerId}:`, {
                containerId: widget.containerId,
                language: widget.language,
                rendered: widget.rendered,
                widgetId: widget.widgetId,
                hasCallback: !!widget.callback,
                completed: widget.rendered ? isCompleted(containerId) : false,
                tokenPresent: response !== 'not rendered' && response !== ''
            });
        });
    }

    /**
     * Enable debug logging
     */
    function enableDebug() {
        debugMode = true;
        console.log('[RecaptchaManager] Debug mode enabled');
        debugDump();
    }

    /**
     * Disable debug logging
     */
    function disableDebug() {
        debugMode = false;
        console.log('[RecaptchaManager] Debug mode disabled');
    }

    // Expose public API
    window.RecaptchaManager = {
        registerWidget: registerWidget,
        getResponse: getResponse,
        isCompleted: isCompleted,
        reset: reset,
        ready: ready,
        injectApiScript: injectApiScript,
        debug: debugDump,
        enableDebug: enableDebug,
        disableDebug: disableDebug
    };

    debug('reCAPTCHA manager initialized');
})();
 /**
 * Centralized Form Validation for The Ski Gathering
 * 
 * Declarative form validation using data attributes. Supports:
 * - Multiple forms per page (isolated instances)
 * - Real-time error clearing on input
 * - Integrated reCAPTCHA validation via RecaptchaManager
 * - Consistent error handling across all forms
 * - Automatic form discovery (no manual initialization)
 * 
 * Setup:
 *   1. Add to bundle (after recaptcha-manager.js)
 *   2. Add data-validation="form" to form element
 *   3. Add data-validation="required" to required fields
 *   4. Add data-validation="email" for email validation
 *   5. Add data-recaptcha-id="widget-id" to form if using reCAPTCHA
 *   6. Add data-error-message="Custom message" to override default errors
 * 
 * Example:
 *   <form id="tsgContactForm" 
 *         data-validation="form" 
 *         data-recaptcha-id="recaptcha-general-contact-en"
 *         method="POST" 
 *         action="processor.php" 
 *         novalidate>
 *       
 *       <input type="text" 
 *              name="Name" 
 *              id="Name" 
 *              data-validation="required"
 *              data-error-message="Please enter your name" />
 *       <span class="error-message" id="error-Name"></span>
 *       
 *       <input type="email" 
 *              name="Email Address" 
 *              id="EmailAddress" 
 *              data-validation="required email"
 *              data-error-message="Please enter your email address" />
 *       <span class="error-message" id="error-EmailAddress"></span>
 *       
 *       <div id="recaptcha-general-contact-en" 
 *            class="recaptchaDiv" 
 *            data-sitekey="..."
 *            data-language="en"></div>
 *       <span class="error-message" id="error-recaptcha"></span>
 *       
 *       <input type="submit" value="Send" data-text="Send Message" data-loading-text="Sending..." />
 *   </form>
 * 
 * @version 1.0.0
 * @date 2025-12-01
 */

(function() {
    'use strict';

    /**
     * FormValidator - Manages validation for a single form instance
     */
    class FormValidator {
        constructor(formElement) {
            this.form = formElement;
            this.submitButton = this.form.querySelector('input[type="submit"], button[type="submit"]');
            
            // RecaptchaManager uses container ID as lookup key
            this.recaptchaContainerId = this.form.getAttribute('data-recaptcha-id');
            
            this.init();
        }

        /**
         * Initialize form validation
         */
        init() {
            // Attach submit handler
            this.form.addEventListener('submit', (e) => this.handleSubmit(e));
            
            // Attach real-time error clearing to all validated fields
            const validatedFields = this.form.querySelectorAll('[data-validation]');
            validatedFields.forEach(field => {
                if (field.tagName !== 'FORM') { // Skip the form element itself
                    field.addEventListener('input', () => this.clearError(field));
                }
            });
        }

        /**
         * Handle form submission
         */
        handleSubmit(e) {
            if (!this.validateForm()) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            
            // Disable submit button to prevent double submission
            this.disableSubmitButton();
        }

        /**
         * Validate entire form
         * @returns {boolean} True if valid, false otherwise
         */
        validateForm() {
            let isValid = true;
            
            // Clear all errors first
            this.clearAllErrors();
            
            // Combine phone fields before validation (if present)
            this.combinePhoneFields();
            
            // Validate all fields with data-validation attribute
            const validatedFields = this.form.querySelectorAll('[data-validation]');
            validatedFields.forEach(field => {
                if (field.tagName !== 'FORM') { // Skip the form element itself
                    if (!this.validateField(field)) {
                        isValid = false;
                    }
                }
            });
            
            // Validate phone if present (custom logic for split phone fields)
            if (!this.validatePhone()) {
                isValid = false;
            }
            
            // Validate reCAPTCHA if present
            if (this.recaptchaContainerId && !this.validateRecaptcha()) {
                isValid = false;
            }
            
            // Scroll to first error
            if (!isValid) {
                this.scrollToFirstError();
            }
            
            return isValid;
        }

        /**
         * Validate a single field
         * @param {HTMLElement} field Field to validate
         * @returns {boolean} True if valid, false otherwise
         */
        validateField(field) {
            const validationRules = field.getAttribute('data-validation');
            if (!validationRules) return true;
            
            const rules = validationRules.split(' ');
            const value = field.value ? field.value.trim() : '';
            const fieldId = field.id || field.name;
            
            // Get custom error message or use default
            const customMessage = field.getAttribute('data-error-message');
            
            // Check 'required' rule
            if (rules.includes('required') && !value) {
                const message = customMessage || this.getDefaultMessage(field, 'required');
                this.showError(fieldId, message);
                return false;
            }
            
            // Check 'email' rule (only if field has value)
            if (rules.includes('email') && value) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    const message = customMessage || this.getDefaultMessage(field, 'email');
                    this.showError(fieldId, message);
                    return false;
                }
            }
            
            return true;
        }

        /**
         * Validate reCAPTCHA widget
         * @returns {boolean} True if valid, false otherwise
         */
        validateRecaptcha() {
            if (!window.RecaptchaManager) {
                console.error('RecaptchaManager not loaded');
                this.showError('recaptcha', 'Security verification unavailable. Please refresh the page.');
                return false;
            }
            
            // RecaptchaManager uses container ID as lookup key (guaranteed unique per widget)
            if (!window.RecaptchaManager.isCompleted(this.recaptchaContainerId)) {
                const recaptchaDiv = document.getElementById(this.recaptchaContainerId);
                if (recaptchaDiv) {
                    recaptchaDiv.classList.add('has-error');
                }
                this.showError('recaptcha', 'Please complete the reCAPTCHA verification');
                return false;
            }
            
            // Clear error state if previously errored (successful validation)
            const recaptchaDiv = document.getElementById(this.recaptchaContainerId);
            if (recaptchaDiv) {
                recaptchaDiv.classList.remove('has-error');
            }
            
            return true;
        }

        /**
         * Combine phone country code + local number into hidden field
         */
        combinePhoneFields() {
            const phoneCountryCode = this.form.querySelector('#tsg-phone-country-code, #contact-phone-country-code');
            const phoneLocal = this.form.querySelector('#tsg-phone-local, #contact-phone-local');
            const phoneCombined = this.form.querySelector('#tsg-phone-combined, #contact-phone-combined');

            if (!phoneCountryCode || !phoneLocal || !phoneCombined) return;

            const code = phoneCountryCode.value.trim();
            const local = phoneLocal.value.trim();

            if (code && local) {
                phoneCombined.value = '+' + code + local;
            } else {
                phoneCombined.value = '';
            }
        }

        /**
         * Validate phone number (split fields)
         * @returns {boolean} True if valid (or not present), false if invalid
         */
        validatePhone() {
            const phoneCountryCode = this.form.querySelector('#tsg-phone-country-code, #contact-phone-country-code');
            const phoneLocal = this.form.querySelector('#tsg-phone-local, #contact-phone-local');

            // Phone fields not present in this form
            if (!phoneCountryCode || !phoneLocal) return true;

            const code = phoneCountryCode.value.trim();
            const local = phoneLocal.value.trim();

            // Check if phone is required (input has 'required' attribute)
            const isRequired = phoneLocal.hasAttribute('required');

            if (!code && !local) {
                if (isRequired) {
                    this.showError('Phone', 'Please select your country dialling code and enter your phone number');
                    return false;
                }
                return true; // Optional and empty is OK
            }

            if (!code) {
                this.showError('Phone', 'Please select your country dialling code');
                return false;
            }

            if (!local) {
                this.showError('Phone', 'Please enter your local phone number');
                return false;
            }

            if (!/^\d+$/.test(local)) {
                this.showError('Phone', 'Please enter digits only - no spaces, letters, or brackets');
                return false;
            }

            if (code === '1' && local.length !== 10) {
                this.showError('Phone', 'US and Canadian numbers require exactly 10 digits after the country code (e.g. 2125551234)');
                return false;
            }

            if (code !== '1' && (local.length < 7 || local.length > 12)) {
                this.showError('Phone', 'Please enter a valid local number (7 to 12 digits, without country code)');
                return false;
            }

            return true;
        }

        /**
         * Get default error message for field and rule
         * @param {HTMLElement} field Field element
         * @param {string} rule Validation rule
         * @returns {string} Default error message
         */
        getDefaultMessage(field, rule) {
            const fieldName = this.getFieldLabel(field);
            
            switch(rule) {
                case 'required':
                    return `Please enter ${fieldName}`;
                case 'email':
                    return 'Please enter a valid email address';
                default:
                    return 'This field is invalid';
            }
        }

        /**
         * Get human-readable field label
         * @param {HTMLElement} field Field element
         * @returns {string} Field label
         */
        getFieldLabel(field) {
            // Try to find associated label
            const label = this.form.querySelector(`label[for="${field.id}"]`);
            if (label) {
                return label.textContent.trim().replace(/[:*]/g, '').toLowerCase();
            }
            
            // Fallback to field name
            const name = field.name || field.id || 'this field';
            return name.replace(/_/g, ' ').toLowerCase();
        }

        /**
         * Show error for a field
         * @param {string} fieldId Field ID or name
         * @param {string} message Error message
         */
        showError(fieldId, message) {
            const input = document.getElementById(fieldId);
            const errorSpan = document.getElementById('error-' + fieldId);
            
            if (input) {
                input.classList.add('has-error');
            }
            
            if (errorSpan) {
                errorSpan.textContent = message;
            }
        }

        /**
         * Clear error for a field
         * @param {HTMLElement} field Field element or field ID
         */
        clearError(field) {
            let fieldId;
            
            if (typeof field === 'string') {
                fieldId = field;
            } else {
                fieldId = field.id || field.name;
            }
            
            const input = document.getElementById(fieldId);
            const errorSpan = document.getElementById('error-' + fieldId);
            
            if (input) {
                input.classList.remove('has-error');
            }
            
            if (errorSpan) {
                errorSpan.textContent = '';
            }
        }

        /**
         * Clear all errors in the form
         */
        clearAllErrors() {
            this.form.querySelectorAll('.has-error').forEach(el => {
                el.classList.remove('has-error');
            });
            
            this.form.querySelectorAll('.error-message').forEach(el => {
                el.textContent = '';
            });
        }

        /**
         * Scroll to first error
         */
        scrollToFirstError() {
            const firstError = this.form.querySelector('.has-error');
            if (firstError) {
                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                
                // Focus after scroll completes
                if (firstError.focus) {
                    setTimeout(() => { 
                        firstError.focus(); 
                    }, 300);
                }
            }
        }

        /**
         * Disable submit button with loading state
         */
        disableSubmitButton() {
            if (!this.submitButton) return;
            
            this.submitButton.disabled = true;
            
            const loadingText = this.submitButton.getAttribute('data-loading-text');
            if (loadingText) {
                if (this.submitButton.tagName === 'INPUT') {
                    this.submitButton.value = loadingText;
                } else {
                    this.submitButton.textContent = loadingText;
                }
            }
        }
    }

    /**
     * Initialize all forms with data-validation="form"
     */
    function initForms() {
        const forms = document.querySelectorAll('[data-validation="form"]');
        
        if (forms.length === 0) {
            // No forms to validate on this page
            return;
        }
        
        forms.forEach(form => {
            new FormValidator(form);
        });
    }

    /**
     * Run initialization after DOM is ready
     */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initForms);
    } else {
        // DOM already loaded
        initForms();
    }

    // Export for debugging
    window.FormValidator = FormValidator;

})();
 // NOTE: reCAPTCHA widget management now handled by recaptcha-manager.js
// The onloadGRecaptchaCallback function has been removed - RecaptchaManager handles all widget rendering
// Widgets are auto-registered via data-sitekey attributes on containers with unique IDs
// Language detection is automatic based on form context or URL path

// Utility functions for universal button text handling (input vs button elements)
function getButtonText($button) {
  if ($button.length === 0) return '';
  
  var elem = $button[0];
  if (elem.tagName === 'BUTTON') {
    var $textSpan = $button.find('.btn-text');
    if ($textSpan.length) {
      return $textSpan.text();
    }
    return $button.text();
  } else {
    // input element
    return $button.val();
  }
}

function setButtonText($button, text) {
  if ($button.length === 0) return;
  
  var elem = $button[0];
  if (elem.tagName === 'BUTTON') {
    var $textSpan = $button.find('.btn-text');
    if ($textSpan.length) {
      $textSpan.text(text);
    } else {
      $button.text(text);
    }
  } else {
    // input element
    $button.val(text);
  }
}

// This method should be defined globally, because a call for this method is added dynamically to a button link
function increaseNumber(theButton) {
  if (window.event) window.event.preventDefault();

  // get input
  var theInput = $(theButton)
    .closest(".increaseDecreaseButtonArea")
    .children('input[type="number"]');

  //get current value
  var currentVal = parseInt($(theInput).val());

  var maxAllowed = parseInt($(theInput).attr("max"));

  //if undefined set as 1
  if (!$.isNumeric(currentVal)) {
    $(theInput).val(1).trigger("input");
  }
  // only increase if below max value
  else if (maxAllowed != null && currentVal == maxAllowed) {
    //do nothing
  } else {
    $(theInput)
      .val(currentVal + 1)
      .trigger("input");
  }
}

// This method should be defined globally, because a call for this method is added dynamically to a button link
function decreaseNumber(theButton) {
  if (window.event) window.event.preventDefault();

  // get input
  var theInput = $(theButton)
    .closest(".increaseDecreaseButtonArea")
    .children('input[type="number"]');

  //get current value
  var currentVal = parseInt($(theInput).val());

  var minAllowed = parseInt($(theInput).attr("min"));

  //if undefined set as 0
  if (!$.isNumeric(currentVal)) {
    $(theInput).val(0).trigger("input");
  }
  // only decrease if above min value
  else if (minAllowed != null && currentVal == minAllowed) {
    //do nothing
  } else {
    $(theInput)
      .val(currentVal - 1)
      .trigger("input");
  }
}

$(document).ready(function () {
  contactFormClosure();
});

const contactFormClosure = (contactWithin = document) => {
  // ******************************** Variables ***************************

  // NOTE: #tsgBookingForm is excluded - it uses its own dedicated booking-engine.js validation system
  const anyFormInPageSelector =
    ".autoProcessContactForm, .processAllFormsTogether, .easyContact";

  const stagesBeforeSubmitIdentifier = {
    stageDataAttribute: "stage-before-submit",
    forwardButtonSelector: '.stageControls [data-button-type="forward"]',
    backwardButtonSelector: '.stageControls [data-button-type="backward"]',
  };
  const stagesContainerSelector = "#leadCaptureForm";
  const submitAreaSelector = "[data-stage-submit]";
  const currentStageClass = "current";

  const fieldsSelectors = {
    spacer: '[name="SpacerForEmail"]',
    title: '[name="TitleForEmail"]',
    subject: "#emailSubject",
    newsletterSignup: 'input[name="NewsletterSignup"]',
    emailAddress: '[name="Email Address"]',
    recaptcha: ".recaptchaDiv",
  };

  const validationIdentifiers = {
    inputErrorClass: "validationError",
    messageErrorClass: "validationErrorMessage",
    requiredClass: "required",
    requiredDataAttribute: "is-required",
    emailClass: "emailAddress",
    emailDataAttribute: "is-email-address",
    phoneDataAttribute: "is-phone",
    phoneIncCountryDataAttribute: "is-phone-with-country-code",
  };

  const submitButtonSelector = '[type="submit"]';

  const successMessageSelector = ".successMessage";

  const increaseDecreaseButtonAreaClass = "increaseDecreaseButtonArea";

  // *********************************************************************

  contactSetup(contactWithin);

  function contactSetup(startingElement) {
    //this sets up the contact form processing.
    //	can also call the setup function setupContactFormProcessing directly (e.g. on delayed Ajax loading)
    $(startingElement)
      .find(anyFormInPageSelector)
      .addBack(anyFormInPageSelector)
      .each(function (i, contactForm) {
        setupContactForm(contactForm);
      });

    // setup spacers and titles (keys need to be unique, so append integer)
    // needs to be done just once (to stop duplicate keys) so we call this here, not in setupContactForm

    $spacerCount = 0;

    $(startingElement)
      .find(fieldsSelectors.spacer)
      .each(function () {
        $(this).attr("name", $(this).attr("name") + $spacerCount);
        $spacerCount++;
      });

    $titleCount = 0;

    $(startingElement)
      .find(fieldsSelectors.title)
      .each(function () {
        $(this).attr("name", $(this).attr("name") + $titleCount);
        $titleCount++;
      });
  }

  function setupContactForm(contactForm) {
    const $contactForm = $(contactForm);

    // if the contact form has stages, we setup the stages, i.e., forward/backward etc.
    setupStages($contactForm);

    // we do a validation for required fields on key up. This is in addition to the validation when the next/submit button clicked
    setupRequiredFieldsOnSpotValidation($contactForm);

    //setup plus minus buttons
    setupPlusMinusButtons($contactForm);

    //setup submit button handling
    $contactForm.on("submit", function (e) {
      // For AJAX forms (.autoProcessContactForm), use custom submission
      if ($contactForm.hasClass("autoProcessContactForm") || $contactForm.hasClass("processAllFormsTogether")) {
        submitContactForm(e);
      } else {
        // For standard POST forms (booking, beginners festival, etc.), validate before allowing native submit
        validateBeforeNativeSubmit(e, $contactForm);
      }
    });
  }

  /**
   * Validates forms that use native POST submission (not AJAX)
   * Prevents redirect to error pages by catching validation failures client-side
   * @param {event} e The form submit event
   * @param {JQueryObject} $theForm The form element
   */
  function validateBeforeNativeSubmit(e, $theForm) {
    const theLanguage = getLanguage($theForm);

    // If form has stages, validate only the submit area (last stage)
    // Otherwise validate the entire form
    let $submitArea = $theForm.find(submitAreaSelector);
    if ($submitArea.length === 0) {
      $submitArea = $theForm;
    }

    // Validate all fields including reCAPTCHA
    if (validateAnArea($submitArea, theLanguage) === false) {
      // Validation failed - prevent form submission
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    // Validation passed - allow native form submission to proceed
    return true;
  }

  // if the contact form has stages, we setup the stages, i.e., forward/backward etc.
  function setupStages($theForm) {
    // some parts of stages, can be technically placed outside the form. So, we get the parent of the form.
    const $stagesContainer = $theForm.closest(stagesContainerSelector);

    // Do we have no stage (step) for this contact form, i.e., all happen in one step?
    if ($stagesContainer.length === 0) {
      return;
    }

    $stagesContainer
      .find(stagesBeforeSubmitIdentifier.forwardButtonSelector)
      .click((e) => {
        handleNavigationButtons(e, true);
      });
    $stagesContainer
      .find(stagesBeforeSubmitIdentifier.backwardButtonSelector)
      .click((e) => {
        handleNavigationButtons(e, false);
      });

    /**
     * handle navigation for forward/backward buttons
     * @param {event} e The native javascript click event argument.
     * @param {bool} isForwardButton Indicates if the call is for forward button or backward.
     * @returns void
     */
    function handleNavigationButtons(e, isForwardButton) {
      e.preventDefault();

      const $currentStage = $stagesContainer.find(
        `[data-${stagesBeforeSubmitIdentifier.stageDataAttribute}].${currentStageClass}`
      );

      const theLanguage = getLanguage($theForm);

      // validate the current stage if needed, this excludes the last stage which the submit stage because we don't have forward button for it
      // of course we don't have validation for backward button
      if (isForwardButton && !validateAnArea($currentStage, theLanguage)) {
        return;
      }

      // handle transition from current stage to the next stage (or previous stage if it is backward button) UI wise.
      handleStagesUiTransition(isForwardButton);
    }

    /**
     * Handle transition from current stage to the next stage (or previous stage if it is backward button) UI wise.
     * @param {bool} isForwardButton Indicates if the call is for forward button or backward.
     */
    function handleStagesUiTransition(isForwardButton) {
      // hide stages container temporarily, until we load the next stage
      $stagesContainer.animate({ opacity: "0" });

      setTimeout(() => {
        // find all elements with the current class, this would be the stage, the buttons and stage progress
        let $element = $stagesContainer
          .find(`.${currentStageClass}`)
          .removeClass(currentStageClass);

        // what would be the next step, forward or backward?
        if (isForwardButton) {
          $element = $element.next();
        } else {
          $element = $element.prev();
        }

        // add the class to the next step
        $element.addClass(currentStageClass);
      }, 600);

      // show stages container again
      $stagesContainer.animate({ opacity: "1.0" });
    }
  }

  /**
   * It adds a validation for required fields on key up. This is in addition to the validation when the next/submit button clicked.
   * @param {JQueryObject} $theForm The form which is converted to a JQuery object.
   */
  function setupRequiredFieldsOnSpotValidation($theForm) {
    // The validation is done for elements that are typeable
    $theForm
      .find("input,textarea")
      .filter(
        `.${validationIdentifiers.requiredClass}, [data-${validationIdentifiers.requiredDataAttribute}]`
      )
      // when the text box is clicked, and user releases a key.
      .keyup((event) => {
        // Converting the current target, i.e., the text box, to a JQuery object.
        const $element = $(event.currentTarget);

        //Remove old validation error classes on this text box, because we want to revalidate the text box again in respect of "required validation"
        $element.removeClass(validationIdentifiers.inputErrorClass);

        //remove old validation messages
        $element
          .next(
            `.${validationIdentifiers.messageErrorClass}[data-error-for="requiredText"]`
          )
          .remove();

        // Now, if the box is empty after releasing the key (in most cases this means the key that was just released was Backspace)
        if ($element.val()?.trim() == "") {
          addErrorMessage($element, "requiredText", getLanguage($theForm));
        }
      });
  }

  /**
   * A utility function to find the current language of the contact page
   * @param {JQueryObject} $theForm he form which is converted to a JQuery object.
   * @returns A string that indicates the language
   */
  function getLanguage($theForm) {
    // set the language. if not set use english as the default
    let theLanguage;

    if ($theForm.attr("data-language")) {
      theLanguage = $theForm.data("language");
    } else {
      theLanguage = "english";
    }
    return theLanguage;
  }

  /**
   * It processes the form to submit to the dedicated PHP processor file
   * @param {event} e The native javascript of form submit argument.
   */
  function submitContactForm(e) {
    // stop default submit form action from happening
    e.preventDefault();

    var $theForm = $(e.target);

    // set the language. if not set use english as the default
    const theLanguage = getLanguage($theForm);

    // if we have stages, we have a submit area which is basically the last stage
    // otherwise for those contact forms that we have only one stage, the whole form is considered as the submit area
    let $submitArea = $theForm.find(submitAreaSelector);
    if ($submitArea.length === 0) {
      $submitArea = $theForm;
    }

    // we first validate the submit area locally, and then post data to the dedicated form processor
    if (validateAnArea($submitArea, theLanguage) !== false) {
      // email subject
      // can use values from multiple fields to create the email subject and they will be concatenated
      $theForm.find(".useForEmailSubject").each(function () {
        $theForm
          .find(fieldsSelectors.subject)
          .val($theForm.find(fieldsSelectors.subject).val() + $(this).val());
      });

      // let user know message is sending
      var $sendButton = $theForm.find(submitButtonSelector);
      var oldButtonMessage = getButtonText($sendButton);
      var loadingText = $sendButton.attr('data-loading-text') || (theLanguage === "french" ? "Envoi..." : "Sending...");

      // while submiting the data, a 'disabled' attribute added to the button. So, we need to have an appropriate styling for this case.
      setButtonText($sendButton, loadingText);
      $sendButton.prop("disabled", true).addClass("sending-with-spinner");

      // send email directly (Mailchimp integration removed - now using Brevo)
      postEmailToServer($theForm, $sendButton, oldButtonMessage, theLanguage);
    }
  }

  /**
   * It filters out empty inputs for when the class hideEmptyFields is used.
   * @param {HtmlElement} theInput Native Html element for the input
   * @returns false if the input is empty, otherwise true..
   */
  function filterEmptyInputs(theInput) {
    return $(theInput).val() !== "";
  }

  /**
   * Posts the data to the server via AJAX to the form's dedicated processor
   * @param {JQueryObject} $theForm he form which is converted to a JQuery object.
   * @param {JQueryObject} $sendButton The submit button, being used to re-enable the button.
   * @param {string} oldButtonMessage The original text for the submit button, being used when the submit button is being re-enabled.
   * @param {string} theLanguage The current language of the page.
   */
  function postEmailToServer(
    $theForm,
    $sendButton,
    oldButtonMessage,
    theLanguage
  ) {
    //get the data to send to server
    var $serializedData;

    $theForm.trigger("beforeSerializingData");

    if ($theForm.hasClass("processAllFormsTogether hideEmptyFields")) {
      $serializedData = $(".processAllFormsTogether input, .processAllFormsTogether textarea, .processAllFormsTogether select")
        .filter(function () {
          return filterEmptyInputs(this) && !this.classList.contains("exclude-from-submit");
        })
        .serialize();

      //$data = $('.processAllFormsTogether :input').serialize();
    } else if ($theForm.hasClass("processAllFormsTogether")) {
      $serializedData = $(".processAllFormsTogether input, .processAllFormsTogether textarea, .processAllFormsTogether select").serialize();
    } else if ($theForm.hasClass("hideEmptyFields")) {
      $serializedData = $theForm
        .find("input, textarea, select")
        .filter(function () {
          return filterEmptyInputs(this) && !this.classList.contains("exclude-from-submit");
        })
        .serialize();

      //$data = $(theForm).find(':input').serialize();
    } else {
      $serializedData = $theForm
        .find("input, textarea, select")
        .filter(function () {
          return !this.classList.contains("exclude-from-submit");
        })
        .serialize();
    }

    // post submission to server via dedicated form processor
    $.ajax({
      type: "post",
      url: $theForm.data("form-processor-location"),
      data: $serializedData,
      beforeSend: () => {
        // we trigger an event on the form, beforeSubmit, so if another js file wants to do something before submitting the data
        $theForm.trigger("beforeSubmit");
        return true;
      },
      success: function (response) {
        // we trigger an event on the form, afterSuccess, so if another js file wants to do something after successful  submission
        $theForm.trigger("afterSuccess", response);

        // re-enable the send button
        resetSendButton();

        const successPage = $theForm.attr("success-page-name");

        if (successPage) {
          // Redirect to the success page if the data attribute is present
          window.location.href = successPage;
        } else {

          //hide the form and show success message (must be sibling to the form and have class successMessage)
          $theForm.fadeOut(500, function () {
            $theForm
              .parent()
              .find(successMessageSelector)
              .fadeIn(100, function () {
                $("html, body").animate(
                  {
                    scrollTop:
                      $theForm
                        .parent()
                        .find(successMessageSelector)
                        .first()
                        .offset().top - 100,
                  },
                  500
                );
              });
          });
        }

        //record success in Google Analytics
        if (ga)
          ga("send", {
            hitType: "event",
            eventCategory: "FormSubmission",
            eventAction: "ButtonClick",
            eventLabel: $theForm.attr("id"),
          });
      },
      error: function (response) {
        // we trigger an event on the form, afterError, so if another js file wants to do something after unsuccessful submission
        $theForm.trigger("afterError", response);

        // we don't have statusText in http/2 (server), so using a custom header, reason-phrase, we created.
        if (
          response.statusText == "Recaptcha Incorrect" ||
          response.getResponseHeader("reason-phrase") == "Recaptcha Incorrect"
        ) {
          addErrorMessage(
            $theForm.find(fieldsSelectors.recaptcha),
            "recaptchaNotTicked",
            theLanguage
          );

          grecaptcha.reset();

          scrollToElementInError();
        } else if (
          response.statusText == "Email Invalid" ||
          response.getResponseHeader("reason-phrase") == "Email Invalid"
        ) {
          addErrorMessage(
            $theForm.find(fieldsSelectors.emailAddress),
            "emailNotValid",
            theLanguage
          );

          grecaptcha.reset();

          scrollToElementInError();
        } else {
          addErrorMessage(
            $theForm.find(submitButtonSelector),
            "unknownError",
            theLanguage
          );
        }

        resetSendButton();
      },
      complete: function (response) {
        // we trigger an event on the form, afterComplete, so if another js file wants to do something after the submission regardless of success or failure of submission
        $theForm.trigger("afterComplete", response);
      },
    });

    /**
     * It re-enables the send button
     */
    function resetSendButton() {
      setButtonText($sendButton, oldButtonMessage);
      $sendButton.prop("disabled", false).removeClass("sending-with-spinner");
      
      // Restore icon if button had a spinner (swap spinner back to checkmark or original icon)
      var $icon = $sendButton.find('i.fa-spinner');
      if ($icon.length) {
        $icon.removeClass('fa-spinner').addClass('fa-check');
      }
    }
  }

  /**
   *
   * @param {JQueryObject} $area The area for which we are removing the validation errors. It could be the submit area or a particular stage.
   */
  function removeOldValidationWarningsFromArea($area) {
    //Remove old validation error classes
    $area
      .find(`.${validationIdentifiers.inputErrorClass}`)
      .removeClass(validationIdentifiers.inputErrorClass);

    //remove old validation messages
    $area.find(`.${validationIdentifiers.messageErrorClass}`).remove();

    firstElementInError = null;
  }

  /**
   * Being used to set the focus on the first element with validation error.
   */
  let firstElementInError = null;

  /**
   * It adds a proper validation error style and message for the element.
   * @param {JQueryObject} $element The element for which we want to add the validation error.
   * @param {string} errCode The validation error type, e.g., required filed error. The codes defined down in this file.
   * @param {string} language The current language of the page.
   */
  function addErrorMessage($element, errCode, language) {
    $element.addClass(validationIdentifiers.inputErrorClass);

    //css hides validationErrorMessages by default, so need to display block here.
    $element.after(
      `<div data-error-for="${errCode}" class="${validationIdentifiers.messageErrorClass}" style="display:block;">` +
      getErrorMessage(errCode, language) +
      "</div>"
    );

    if (firstElementInError == null) {
      firstElementInError = $element;
    }
  }

  /**
   * Scroll to first element in error
   */
  function scrollToElementInError() {
    firstElementInError.focus();
    firstElementInError = null;
  }

  //*************** error messages *****************

  //object type to store useful error messages in

  function errorCodeDescriptor(errorCode, english, french) {
    this.errorCode = errorCode;
    this.english = english;
    this.french = french;
  }

  const errorCodes = [];

  errorCodes.push(
    new errorCodeDescriptor(
      "http",
      "http is not allowed in entries",
      "http n'est pas autoris&eacute;"
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "requiredText",
      "Please enter a value.",
      "Entrez une valeur, il est n&eacute;cessaire"
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "requiredCheck",
      "This is required to continue. Thank you.",
      "Ceci est n&eacute;cessaire pour continuer. Je vous remercie."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "requiredSelection",
      "Please select an option.",
      "Veuillez s&eacute;lectionner une option. Je vous remercie"
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "emailNotValid",
      "Please check your email address.",
      "V&eacute;rifiez votre adresse e-mail, cela ne semble pas &ecirc;tre valide. Je vous remercie."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "phoneNotValid",
      "Please check your phone number.",
      "Veuillez v&eacute;rifiez votre num&eacutero de t&eacutel&eacutephone, Celui-ci ne semble pas &ecirc;tre valide. Je vous remercie."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "phoneIncCountryNotValid",
      "Please check your phone number. Please include the country code starting with + (e.g +353 / +44), but do not include any brackets.",
      "Veuillez v&eacute;rifiez votre num&eacutero de t&eacutel&eacutephone. Veuillez inclure le code du pays commençant par +33, +44 etc."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "valuesDoNotMatch",
      "Please check. These values do not match.",
      "V&eacute;rifiez s&apos;il vous pla&icirc;t. Ces valeurs ne correspondent pas. Je vous remercie."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "recaptchaNotTicked",
      "Please tick the 'I'm not a Robot' box. Thank you.",
      "Veuillez compl&eacute;ter l'anti-spam en cochant la case. Je vous remercie."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "singleOccupancyNotSelected2PerRoom",
      "You must select the number of Single Occupancy Rooms you require (max 2 people per room).",
      "You must select the number of Single Occupancy Rooms you require (max 2 people per room)."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "unknownError",
      "I'm sorry, there was an error and the message cannot be sent. Please email or phone us instead. We're sorry for the inconvenience.",
      "Je suis d&eacute;sol&eacute;, il y a eu une erreur et le message ne peut pas &ecirc;tre envoy&eacute;. Pourriez-vous nous envoyer un courriel ou nous t&eacute;l&eacute;phoner plut&ocirc;t s'il vous plait? Nous nous excusons pour le d&eacute;sagr&eacute;ment."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "voucherCodeInvalid",
      "I'm sorry, that does not appear to be a valid voucher code.",
      "Je suis d&eacute;sol&eacute;, cela ne semble pas &ecirc;tre un code de bon valable."
    )
  );

  errorCodes.push(
    new errorCodeDescriptor(
      "voucherCodeExpired",
      "I'm sorry, that voucher code has expired.",
      "Je suis d&eacute;sol&eacute;, ce code de bon a expir&eacute;."
    )
  );

  function getErrorMessage(errCode, language) {
    for (var i = 0, len = errorCodes.length; i < len; i++) {
      if (errorCodes[i]["errorCode"] == errCode) {
        return errorCodes[i][language];
      }
    }
  }

  /**
   * It validates the area, could be the submit area or one particular stage.
   * @param {JQueryObject} $area The area for which we are doing the validation, i.e., submit area or a particular stage.
   * @param {string} theLanguage The current language of the page.
   * @returns true if the area is valid, otherwise false.
   */
  function validateAnArea($area, theLanguage) {
    removeOldValidationWarningsFromArea($area);

    let validationSuccess = true;

    // check all fields
    $area
      .find(`input:not(${submitButtonSelector}), textarea, select`)
      .each(function () {
        const $element = $(this);

        // Check for code insertion
        if ($element.val().toLowerCase().indexOf("http") != -1) {
          addErrorMessage($element, "http", theLanguage);
          validationSuccess = false;
        }

        //check if is required
        if (
          $element.hasClass(validationIdentifiers.requiredClass) ||
          $element.data(validationIdentifiers.requiredDataAttribute) !==
          undefined
        ) {
          if ($element.is("input,textarea") && $element.val()?.trim() == "") {
            addErrorMessage($element, "requiredText", theLanguage);
            validationSuccess = false;
          }

          if (
            $element.is('input[type="checkbox"]') &&
            !$element.prop("checked")
          ) {
            addErrorMessage($element, "requiredCheck", theLanguage);
            validationSuccess = false;
          }

          if ($element.is("select") && $element.val() == "notSet") {
            addErrorMessage($element, "requiredSelection", theLanguage);
            validationSuccess = false;
          }
        }

        //check if is an email address
        if (
          ($element.hasClass(validationIdentifiers.emailClass) ||
            $element.data(validationIdentifiers.emailDataAttribute) !==
            undefined) &&
          $element.val() != ""
        ) {
          if ($element.val().indexOf("@") == -1) {
            addErrorMessage($element, "emailNotValid", theLanguage);
            validationSuccess = false;
          }
        }

        ///^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g
        //check if is a phone number, we are using a regular expression for this
        if (
          $element.data(validationIdentifiers.phoneDataAttribute) !==
          undefined &&
          $element.val() != "" &&
          !$element
            .val()
            .match(
              /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
            )?.length
        ) {
          addErrorMessage($element, "phoneNotValid", theLanguage);
          validationSuccess = false;
        }

        //check if is a phone number, we are using a regular expression for this
        if (
          $element.data(validationIdentifiers.phoneIncCountryDataAttribute) !==
          undefined &&
          $element.val() != "" &&
          !$element.val().match(/^[\+]{1}[0-9 ]{12,18}$/im)?.length
        ) {
          addErrorMessage($element, "phoneIncCountryNotValid", theLanguage);
          validationSuccess = false;
        }

        if ($element.data("matching-field")) {
          var baseValue = $element.val();

          var matchingFieldValue = $element.data("matching-field");

          // get all the matching fields
          $area
            .find("[data-matching-field='" + matchingFieldValue + "']")
            .each(function (index, toMatchElement) {
              if ($(toMatchElement).val() != baseValue) {
                addErrorMessage(
                  $(toMatchElement),
                  "valuesDoNotMatch",
                  theLanguage
                );
                validationSuccess = false;
              }
            });
        }
      });

    //Check if google recaptcha has been passed (using RecaptchaManager v2.0)
    var $recaptchaContainer = $area.find(fieldsSelectors.recaptcha);
    if ($recaptchaContainer.length > 0) {
      var recaptchaContainerId = $recaptchaContainer.attr('id');
      
      if (recaptchaContainerId && typeof window.RecaptchaManager !== 'undefined') {
        if (!window.RecaptchaManager.isCompleted(recaptchaContainerId)) {
          $recaptchaContainer.addClass(validationIdentifiers.inputErrorClass);

          addErrorMessage(
            $recaptchaContainer,
            "recaptchaNotTicked",
            theLanguage
          );

          validationSuccess = false;
        }
      }
    }

    //scroll to first element in error
    if (!validationSuccess) {
      scrollToElementInError();
    }

    //All conditions passed so return true.
    return validationSuccess;
  }

  function setupPlusMinusButtons($contactForm) {
    $contactForm.find('input[type="number"]').each(function () {
      //see if it's already been setup. This way we can call this function again later on when extra number inputs have been created.
      if (!$(this).next().hasClass(increaseDecreaseButtonAreaClass)) {
        $(this).wrap(`<div class="${increaseDecreaseButtonAreaClass}"></div>`);

        $(this).before(
          '<div onclick="decreaseNumber($(this))" class="decreaseButton"><i class="fa fa-fw fa-minus"></i></div>'
        );

        $(this).after(
          '<div onclick="increaseNumber($(this))" class="increaseButton"><i class="fa fa-fw fa-plus"></i></div>'
        );
      }
    });
  }
};
 
var windowClick = function(e){	
	
	
	// Define list of menus
	menusList = [".mainNav", ".languageSelector"];
	
	
	//loop through each menu in menusList:
	$.each(menusList, function( index, theMenu ) {
		
		//if theMenu is open
		if($(theMenu+'>li.selected').length>0){
			
			
			// if click has not come from theMenu
			if (!$(e.target).closest(theMenu).length) {
				
				
				//stop any other actions happening (e.g. following a link)
				e.preventDefault();
				e.stopPropagation();
				
				//Hide the theMenu
				$(theMenu).find('.selected').removeClass('selected');
			};
		};
	});
	
};





//Only do the below when the document is ready
$(document).ready(function(){
	
	//Handle window clicks so we know when someone's clicked outside the menu (to close it)
	//		True part at end is the useCapture property. If set to true then this gets the click event first, before any other (child) elements
	window.addEventListener("click", windowClick, true); 
	
	
	var submenuSelector = ".mainNav li.isSubmenuSelector, .languageSelector li";
	
	$(submenuSelector).click(function(e){
		
		
		if (!e.isDefaultPrevented()) {
			
			//only run code section if click event source was subMenu Selector
			if ($(this).is(submenuSelector) ){
									
				
				//See if menu is already open
				if( $(this).hasClass('selected') ){
					
					//if it is already open, close it and its descendents
					$(this).removeClass('selected');
					$(this).find('ul').removeClass('selected');
					
					
					
				} else {
					
					//remove class "selected" from all siblings and their children
					$(this).siblings('li').removeClass('selected').find('ul, li').removeClass('selected');
					
					
					//add the class "selected" to the <li> which has been clicked
					$(this).addClass('selected');
					
					
					// and to any of its children which are <ul>
					$(this).children('ul').addClass('selected');
					
				}	
				
				
				//stop parents of the isSubmenuSelector also firing their click events
				e.stopPropagation();
				
			}
		}
		
	});
	
	
	
});




 // do not use this on these pages. They use a hash for other purposes than anchor link
var pagesToIgnore = [
  "https://www.myirelandtour.com/mybooking/escorted-group-tours.php",
  "https://www.myirelandtour.com/mybooking/private-tours.php",
];

// checks for the URLs to ignore from above
function urlChecker(urlToCheck) {
  for (var i = 0; i < pagesToIgnore.length; i++) {
    if (urlToCheck.indexOf(pagesToIgnore[i]) > -1) {
      return false;
    }
  }
  return true;
}

(function ($) {
  //create closure so we can safely use $ as alias for jQuery

  $(document).ready(function () {
    //check if it's an external anchor link
    if (window.location.hash && urlChecker(window.location.href)) {
      var hash = window.location.hash;
      $target = $(hash + ", [name=" + hash.slice(1) + "]");

      if ($target.length) {
        //open expander / contractor first if required

        //check if target is in hidden expander / contractor
        var $toggleContainerHidden = $target.closest(
          ".toggle_container:hidden"
        );

        if ($toggleContainerHidden.length) {
          toggleNow($toggleContainerHidden, true);
        }

        // check if target is toggle trigger. If so, expand it's target
        if ($target.hasClass("toggle_trigger")) {
          $target.click();
        }

        $("html,body").animate(
          {
            scrollTop: $target.offset().top - 20,
          },
          300
        );
      }
    }

    // smooth scrolling for anchor links within a page
    $("a[href*=\\#]:not([href=\\#])").click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash + ", [name=" + this.hash.slice(1) + "]");
        if (target.length) {
          //open expander / contractor first if required

          //check if target is in hidden expander / contractor
          var $toggleContainerHidden = $(target).closest(
            ".toggle_container:hidden"
          );

          if ($toggleContainerHidden.length) {
            toggleNow($toggleContainerHidden, true);
          }

          // check if target is toggle trigger. If so, expand it's target
          if (target.hasClass("toggle_trigger")) {
            target.click();
          }

          $("html,body").animate(
            {
              scrollTop: target.offset().top - 20,
            },
            1000
          );

          // Update URL with hash after smooth scroll
          if (history.pushState) {
            history.pushState(null, null, this.hash);
          } else {
            location.hash = this.hash;
          }

          return false;
        }
      }
    });
  });
})(jQuery);
 //Useful Functions **************************

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

//setup ********************************************
(function ($) {
  $(document).ready(function () {
    toggleSetup(document);

    // track scrolling for fixed positioning of toggle close button
    window.addEventListener("scroll", setFixedCloseButtonVisability);
  });
})(jQuery);

function toggleSetup(startingElement) {
  //$(startingElement).find(".toggle_container").addBack(".toggle_container").hide();

  $(startingElement)
    .find(".toggle_trigger")
    .click(function () {
      toggleNow($(this).siblings(".toggle_container"));
    });

  $(startingElement)
    .find(".toggleOnMobile_trigger")
    .click(function () {
      toggleNow($(this).siblings(".toggle_container"));
    });

  $(".toggle_focus_trigger").focus(function () {
    var $toggleContainer = $(this)
      .closest(".toggle_wrapper")
      .find(".toggle_container")
      .first();

    $toggleContainer.slideDown("slow");

    reloadGoogleMaps($toggleContainer);
  });

  $(".toggle_click_trigger").click(function () {
    var $toggleContainer = $(this)
      .closest(".toggle_wrapper")
      .find(".toggle_container")
      .first();

    $toggleContainer.slideToggle("slow");

    reloadGoogleMaps($toggleContainer);

    /* UNCOMMENT THIS AND TEST WHEN PUTTING LIVE 
		recordEvent(window.location.href, 'ToggleTriggerClick', jQuery(this).text()); */
  });
}

function toggleNow($toggleContainer, toggleInstantly) {
  // if toggleInstantly = true then don't use slide effects

  $toggleTrigger = $toggleContainer.siblings(".toggle_trigger");

  //toggle "active" class on trigger
  $toggleTrigger.toggleClass("active");

  //see if opening or closing
  var opening = $toggleTrigger.hasClass("active");

  //toggle "active" class on wrapper
  $toggleContainer.parent().toggleClass("active");

  //slide the container
  if (toggleInstantly) {
    $toggleContainer.toggle();
  } else {
    $toggleContainer.slideToggle("slow");
  }

  //if closing then hide extra close button
  if (!opening) {
    $toggleContainer.find(".toggleFixedCloserWrapper").remove();
  }

  // reload google maps
  reloadGoogleMaps($toggleContainer);
}

function toggleNow_toggleOnMobile($toggleContainer, toggleInstantly) {
  // if toggleInstantly = true then don't use slide effects

  $toggleTrigger = $toggleContainer.siblings(".toggleOnMobile_trigger");

  //toggle "active" class on trigger
  $toggleTrigger.toggleClass("toggled");

  //see if opening or closing
  var opening = $toggleTrigger.hasClass("toggled");

  //toggle "active" class on wrapper
  $toggleContainer.parent().toggleClass("toggled");

  //slide the container
  if (toggleInstantly) {
    $toggleContainer.toggle();
  } else {
    $toggleContainer.slideToggle("slow");
  }

  //if closing then hide extra close button
  if (!opening) {
    $toggleContainer.find(".toggleFixedCloserWrapper").remove();
  }

  // reload google maps
  reloadGoogleMaps($toggleContainer);
}

var setFixedCloseButtonVisability = debounce(function () {
  //small toggle areas dont need these
  var minHeightForFixedCloseButton = 400;

  //get all open toggles
  $(".toggle_container:visible").each(function () {
    var $toggleContainer = $(this);
    var $toggleTrigger = $toggleContainer.siblings(".toggle_trigger");

    if (
      window.scrollY > $toggleContainer.offset().top + 40 &&
      window.scrollY <
        $toggleContainer.offset().top + $toggleContainer.height() &&
      $toggleContainer.height() > minHeightForFixedCloseButton
    ) {
      //check if already added
      if (!$toggleContainer.find(".toggleFixedCloserWrapper").length) {
        $toggleContainer.append(
          '<div class="toggleFixedCloserWrapper" style="display:none;"><div class="toggleFixedCloserBtn" onclick="toggleFixedCloserBtnClick(this)" ><i class="fas fa-fw fa-chevron-up"></i></div></div>'
        );

        $toggleContainer.find(".toggleFixedCloserWrapper").fadeIn(400);
      }
    } else {
      //if in wrong scroll distance (i.e. above of below element) then hide extra close button

      $toggleContainer
        .find(".toggleFixedCloserWrapper")
        .fadeOut(200, function () {
          $(this).remove();
        });
    }
  });
}, 50);

function toggleFixedCloserBtnClick(btn) {
  var $toggleContainer = $(btn).closest(".toggle_container");
  var $toggleTrigger = $toggleContainer.siblings(".toggle_trigger");

  //scroll up
  $("html, body")
    .animate(
      {
        scrollTop: $toggleTrigger.first().offset().top - 50,
      },
      800
    )
    .promise()
    .then(function () {
      // then close toggle
      toggleNow($toggleContainer);
    });
}

function reloadGoogleMaps($toggleContainer) {
  // google maps workaround
  //		google mymaps needs reloading when displayed as it does not work properly when iframe is loaded into a hidden area of html

  $toggleContainer.find(".iframeNeedsReloadingOnDisplay").each(function () {
    if (!$(this).attr("data-hasreloaded")) {
      //reload the iframe
      $(this).attr("src", $(this).attr("src"));

      //add marker so we don't reload again
      $(this).attr("data-hasreloaded", true);
    }
  });
}
 
function videoLoad() {
       var vidDefer = document.getElementsByTagName('iframe');
              for (var i = 0; i < vidDefer.length; i++) {
                     if (vidDefer[i].getAttribute('data-src')) {

                     vidDefer[i].setAttribute('src', vidDefer[i].getAttribute('data-src'));
              }
       }
}


window.onload = videoLoad;
 // BELOW HAS BEEN DISABLED BY DAN - SHOULD NO LONGER BE NEEDED SO LONG AS SITE HAS CLASS .internetExplorer ON HTML TAG SEE TSG NEW SITE FOR EXAMPLE
// work around for lack of objectfit support in IE
//jQuery(document).ready(function(){

//if IE or EDGE <15
//if(document.createElement('div').style.objectFit === undefined){


//$('.fold img, .layeredContent img').each(function(){
//var imgSrc = $(this).attr('src');
//var fitType = 'cover';

// if($(this).data('fit-type')) {
// fitType = $(this).data('fit-type');
// }

//$(this).closest("div").css({ 'background' : 'transparent url("'+imgSrc+'") no-repeat center center/'+fitType, });
//$(this).remove(); 

//});


//};



//});	



// below is TouchSwipe and Lightbox, both of which are required by the Photo Common Library


/*!
 * @fileOverview TouchSwipe - jQuery Plugin
 * @version 1.6.18
 *
 * @author Matt Bryson http://www.github.com/mattbryson
 * @see https://github.com/mattbryson/TouchSwipe-Jquery-Plugin
 * @see http://labs.rampinteractive.co.uk/touchSwipe/
 * @see http://plugins.jquery.com/project/touchSwipe
 * @license
 * Copyright (c) 2010-2015 Matt Bryson
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 */


(function (factory) {
  if (typeof define === 'function' && define.amd && define.amd.jQuery) {
    // AMD. Register as anonymous module.
    define(['jquery'], factory);
  } else if (typeof module !== 'undefined' && module.exports) {
    // CommonJS Module
    factory(require("jquery"));
  } else {
    // Browser globals.
    factory(jQuery);
  }
}(function ($) {
  "use strict";

  //Constants
  var VERSION = "1.6.18",
    LEFT = "left",
    RIGHT = "right",
    UP = "up",
    DOWN = "down",
    IN = "in",
    OUT = "out",

    NONE = "none",
    AUTO = "auto",

    SWIPE = "swipe",
    PINCH = "pinch",
    TAP = "tap",
    DOUBLE_TAP = "doubletap",
    LONG_TAP = "longtap",
    HOLD = "hold",

    HORIZONTAL = "horizontal",
    VERTICAL = "vertical",

    ALL_FINGERS = "all",

    DOUBLE_TAP_THRESHOLD = 10,

    PHASE_START = "start",
    PHASE_MOVE = "move",
    PHASE_END = "end",
    PHASE_CANCEL = "cancel",

    SUPPORTS_TOUCH = 'ontouchstart' in window,

    SUPPORTS_POINTER_IE10 = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled && !SUPPORTS_TOUCH,

    SUPPORTS_POINTER = (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && !SUPPORTS_TOUCH,

    PLUGIN_NS = 'TouchSwipe';



  /**
  * The default configuration, and available options to configure touch swipe with.
  * You can set the default values by updating any of the properties prior to instantiation.
  * @name $.fn.swipe.defaults
  * @namespace
  * @property {int} [fingers=1] The number of fingers to detect in a swipe. Any swipes that do not meet this requirement will NOT trigger swipe handlers.
  * @property {int} [threshold=75] The number of pixels that the user must move their finger by before it is considered a swipe.
  * @property {int} [cancelThreshold=null] The number of pixels that the user must move their finger back from the original swipe direction to cancel the gesture.
  * @property {int} [pinchThreshold=20] The number of pixels that the user must pinch their finger by before it is considered a pinch.
  * @property {int} [maxTimeThreshold=null] Time, in milliseconds, between touchStart and touchEnd must NOT exceed in order to be considered a swipe.
  * @property {int} [fingerReleaseThreshold=250] Time in milliseconds between releasing multiple fingers.  If 2 fingers are down, and are released one after the other, if they are within this threshold, it counts as a simultaneous release.
  * @property {int} [longTapThreshold=500] Time in milliseconds between tap and release for a long tap
  * @property {int} [doubleTapThreshold=200] Time in milliseconds between 2 taps to count as a double tap
  * @property {function} [swipe=null] A handler to catch all swipes. See {@link $.fn.swipe#event:swipe}
  * @property {function} [swipeLeft=null] A handler that is triggered for "left" swipes. See {@link $.fn.swipe#event:swipeLeft}
  * @property {function} [swipeRight=null] A handler that is triggered for "right" swipes. See {@link $.fn.swipe#event:swipeRight}
  * @property {function} [swipeUp=null] A handler that is triggered for "up" swipes. See {@link $.fn.swipe#event:swipeUp}
  * @property {function} [swipeDown=null] A handler that is triggered for "down" swipes. See {@link $.fn.swipe#event:swipeDown}
  * @property {function} [swipeStatus=null] A handler triggered for every phase of the swipe. See {@link $.fn.swipe#event:swipeStatus}
  * @property {function} [pinchIn=null] A handler triggered for pinch in events. See {@link $.fn.swipe#event:pinchIn}
  * @property {function} [pinchOut=null] A handler triggered for pinch out events. See {@link $.fn.swipe#event:pinchOut}
  * @property {function} [pinchStatus=null] A handler triggered for every phase of a pinch. See {@link $.fn.swipe#event:pinchStatus}
  * @property {function} [tap=null] A handler triggered when a user just taps on the item, rather than swipes it. If they do not move, tap is triggered, if they do move, it is not.
  * @property {function} [doubleTap=null] A handler triggered when a user double taps on the item. The delay between taps can be set with the doubleTapThreshold property. See {@link $.fn.swipe.defaults#doubleTapThreshold}
  * @property {function} [longTap=null] A handler triggered when a user long taps on the item. The delay between start and end can be set with the longTapThreshold property. See {@link $.fn.swipe.defaults#longTapThreshold}
  * @property (function) [hold=null] A handler triggered when a user reaches longTapThreshold on the item. See {@link $.fn.swipe.defaults#longTapThreshold}
  * @property {boolean} [triggerOnTouchEnd=true] If true, the swipe events are triggered when the touch end event is received (user releases finger).  If false, it will be triggered on reaching the threshold, and then cancel the touch event automatically.
  * @property {boolean} [triggerOnTouchLeave=false] If true, then when the user leaves the swipe object, the swipe will end and trigger appropriate handlers.
  * @property {string|undefined} [allowPageScroll='auto'] How the browser handles page scrolls when the user is swiping on a touchSwipe object. See {@link $.fn.swipe.pageScroll}.  <br/><br/>
  									<code>"auto"</code> : all undefined swipes will cause the page to scroll in that direction. <br/>
  									<code>"none"</code> : the page will not scroll when user swipes. <br/>
  									<code>"horizontal"</code> : will force page to scroll on horizontal swipes. <br/>
  									<code>"vertical"</code> : will force page to scroll on vertical swipes. <br/>
  * @property {boolean} [fallbackToMouseEvents=true] If true mouse events are used when run on a non touch device, false will stop swipes being triggered by mouse events on non tocuh devices.
  * @property {string} [excludedElements=".noSwipe"] A jquery selector that specifies child elements that do NOT trigger swipes. By default this excludes elements with the class .noSwipe .
  * @property {boolean} [preventDefaultEvents=true] by default default events are cancelled, so the page doesn't move.  You can dissable this so both native events fire as well as your handlers.

  */
  var defaults = {
    fingers: 1,
    threshold: 75,
    cancelThreshold: null,
    pinchThreshold: 20,
    maxTimeThreshold: null,
    fingerReleaseThreshold: 250,
    longTapThreshold: 500,
    doubleTapThreshold: 200,
    swipe: null,
    swipeLeft: null,
    swipeRight: null,
    swipeUp: null,
    swipeDown: null,
    swipeStatus: null,
    pinchIn: null,
    pinchOut: null,
    pinchStatus: null,
    click: null, //Deprecated since 1.6.2
    tap: null,
    doubleTap: null,
    longTap: null,
    hold: null,
    triggerOnTouchEnd: true,
    triggerOnTouchLeave: false,
    allowPageScroll: "auto",
    fallbackToMouseEvents: true,
    excludedElements: ".noSwipe",
    preventDefaultEvents: true
  };



  /**
   * Applies TouchSwipe behaviour to one or more jQuery objects.
   * The TouchSwipe plugin can be instantiated via this method, or methods within
   * TouchSwipe can be executed via this method as per jQuery plugin architecture.
   * An existing plugin can have its options changed simply by re calling .swipe(options)
   * @see TouchSwipe
   * @class
   * @param {Mixed} method If the current DOMNode is a TouchSwipe object, and <code>method</code> is a TouchSwipe method, then
   * the <code>method</code> is executed, and any following arguments are passed to the TouchSwipe method.
   * If <code>method</code> is an object, then the TouchSwipe class is instantiated on the current DOMNode, passing the
   * configuration properties defined in the object. See TouchSwipe
   *
   */
  $.fn.swipe = function (method) {
    var $this = $(this),
      plugin = $this.data(PLUGIN_NS);

    //Check if we are already instantiated and trying to execute a method
    if (plugin && typeof method === 'string') {
      if (plugin[method]) {
        return plugin[method].apply(plugin, Array.prototype.slice.call(arguments, 1));
      } else {
        $.error('Method ' + method + ' does not exist on jQuery.swipe');
      }
    }

    //Else update existing plugin with new options hash
    else if (plugin && typeof method === 'object') {
      plugin['option'].apply(plugin, arguments);
    }

    //Else not instantiated and trying to pass init object (or nothing)
    else if (!plugin && (typeof method === 'object' || !method)) {
      return init.apply(this, arguments);
    }

    return $this;
  };

  /**
   * The version of the plugin
   * @readonly
   */
  $.fn.swipe.version = VERSION;



  //Expose our defaults so a user could override the plugin defaults
  $.fn.swipe.defaults = defaults;

  /**
   * The phases that a touch event goes through.  The <code>phase</code> is passed to the event handlers.
   * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
   * @namespace
   * @readonly
   * @property {string} PHASE_START Constant indicating the start phase of the touch event. Value is <code>"start"</code>.
   * @property {string} PHASE_MOVE Constant indicating the move phase of the touch event. Value is <code>"move"</code>.
   * @property {string} PHASE_END Constant indicating the end phase of the touch event. Value is <code>"end"</code>.
   * @property {string} PHASE_CANCEL Constant indicating the cancel phase of the touch event. Value is <code>"cancel"</code>.
   */
  $.fn.swipe.phases = {
    PHASE_START: PHASE_START,
    PHASE_MOVE: PHASE_MOVE,
    PHASE_END: PHASE_END,
    PHASE_CANCEL: PHASE_CANCEL
  };

  /**
   * The direction constants that are passed to the event handlers.
   * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
   * @namespace
   * @readonly
   * @property {string} LEFT Constant indicating the left direction. Value is <code>"left"</code>.
   * @property {string} RIGHT Constant indicating the right direction. Value is <code>"right"</code>.
   * @property {string} UP Constant indicating the up direction. Value is <code>"up"</code>.
   * @property {string} DOWN Constant indicating the down direction. Value is <code>"cancel"</code>.
   * @property {string} IN Constant indicating the in direction. Value is <code>"in"</code>.
   * @property {string} OUT Constant indicating the out direction. Value is <code>"out"</code>.
   */
  $.fn.swipe.directions = {
    LEFT: LEFT,
    RIGHT: RIGHT,
    UP: UP,
    DOWN: DOWN,
    IN: IN,
    OUT: OUT
  };

  /**
   * The page scroll constants that can be used to set the value of <code>allowPageScroll</code> option
   * These properties are read only
   * @namespace
   * @readonly
   * @see $.fn.swipe.defaults#allowPageScroll
   * @property {string} NONE Constant indicating no page scrolling is allowed. Value is <code>"none"</code>.
   * @property {string} HORIZONTAL Constant indicating horizontal page scrolling is allowed. Value is <code>"horizontal"</code>.
   * @property {string} VERTICAL Constant indicating vertical page scrolling is allowed. Value is <code>"vertical"</code>.
   * @property {string} AUTO Constant indicating either horizontal or vertical will be allowed, depending on the swipe handlers registered. Value is <code>"auto"</code>.
   */
  $.fn.swipe.pageScroll = {
    NONE: NONE,
    HORIZONTAL: HORIZONTAL,
    VERTICAL: VERTICAL,
    AUTO: AUTO
  };

  /**
   * Constants representing the number of fingers used in a swipe.  These are used to set both the value of <code>fingers</code> in the
   * options object, as well as the value of the <code>fingers</code> event property.
   * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
   * @namespace
   * @readonly
   * @see $.fn.swipe.defaults#fingers
   * @property {string} ONE Constant indicating 1 finger is to be detected / was detected. Value is <code>1</code>.
   * @property {string} TWO Constant indicating 2 fingers are to be detected / were detected. Value is <code>2</code>.
   * @property {string} THREE Constant indicating 3 finger are to be detected / were detected. Value is <code>3</code>.
   * @property {string} FOUR Constant indicating 4 finger are to be detected / were detected. Not all devices support this. Value is <code>4</code>.
   * @property {string} FIVE Constant indicating 5 finger are to be detected / were detected. Not all devices support this. Value is <code>5</code>.
   * @property {string} ALL Constant indicating any combination of finger are to be detected.  Value is <code>"all"</code>.
   */
  $.fn.swipe.fingers = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    ALL: ALL_FINGERS
  };

  /**
   * Initialise the plugin for each DOM element matched
   * This creates a new instance of the main TouchSwipe class for each DOM element, and then
   * saves a reference to that instance in the elements data property.
   * @internal
   */
  function init(options) {
    //Prep and extend the options
    if (options && (options.allowPageScroll === undefined && (options.swipe !== undefined || options.swipeStatus !== undefined))) {
      options.allowPageScroll = NONE;
    }

    //Check for deprecated options
    //Ensure that any old click handlers are assigned to the new tap, unless we have a tap
    if (options.click !== undefined && options.tap === undefined) {
      options.tap = options.click;
    }

    if (!options) {
      options = {};
    }

    //pass empty object so we dont modify the defaults
    options = $.extend({}, $.fn.swipe.defaults, options);

    //For each element instantiate the plugin
    return this.each(function () {
      var $this = $(this);

      //Check we havent already initialised the plugin
      var plugin = $this.data(PLUGIN_NS);

      if (!plugin) {
        plugin = new TouchSwipe(this, options);
        $this.data(PLUGIN_NS, plugin);
      }
    });
  }

  /**
   * Main TouchSwipe Plugin Class.
   * Do not use this to construct your TouchSwipe object, use the jQuery plugin method $.fn.swipe(); {@link $.fn.swipe}
   * @private
   * @name TouchSwipe
   * @param {DOMNode} element The HTML DOM object to apply to plugin to
   * @param {Object} options The options to configure the plugin with.  @link {$.fn.swipe.defaults}
   * @see $.fh.swipe.defaults
   * @see $.fh.swipe
   * @class
   */
  function TouchSwipe(element, options) {

    //take a local/instacne level copy of the options - should make it this.options really...
    var options = $.extend({}, options);

    var useTouchEvents = (SUPPORTS_TOUCH || SUPPORTS_POINTER || !options.fallbackToMouseEvents),
      START_EV = useTouchEvents ? (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerDown' : 'pointerdown') : 'touchstart') : 'mousedown',
      MOVE_EV = useTouchEvents ? (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerMove' : 'pointermove') : 'touchmove') : 'mousemove',
      END_EV = useTouchEvents ? (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerUp' : 'pointerup') : 'touchend') : 'mouseup',
      LEAVE_EV = useTouchEvents ? (SUPPORTS_POINTER ? 'mouseleave' : null) : 'mouseleave', //we manually detect leave on touch devices, so null event here
      CANCEL_EV = (SUPPORTS_POINTER ? (SUPPORTS_POINTER_IE10 ? 'MSPointerCancel' : 'pointercancel') : 'touchcancel');



    //touch properties
    var distance = 0,
      direction = null,
      currentDirection = null,
      duration = 0,
      startTouchesDistance = 0,
      endTouchesDistance = 0,
      pinchZoom = 1,
      pinchDistance = 0,
      pinchDirection = 0,
      maximumsMap = null;



    //jQuery wrapped element for this instance
    var $element = $(element);

    //Current phase of th touch cycle
    var phase = "start";

    // the current number of fingers being used.
    var fingerCount = 0;

    //track mouse points / delta
    var fingerData = {};

    //track times
    var startTime = 0,
      endTime = 0,
      previousTouchEndTime = 0,
      fingerCountAtRelease = 0,
      doubleTapStartTime = 0;

    //Timeouts
    var singleTapTimeout = null,
      holdTimeout = null;

    // Add gestures to all swipable areas if supported
    try {
      $element.bind(START_EV, touchStart);
      $element.bind(CANCEL_EV, touchCancel);
    } catch (e) {
      $.error('events not supported ' + START_EV + ',' + CANCEL_EV + ' on jQuery.swipe');
    }

    //
    //Public methods
    //

    /**
     * re-enables the swipe plugin with the previous configuration
     * @function
     * @name $.fn.swipe#enable
     * @return {DOMNode} The Dom element that was registered with TouchSwipe
     * @example $("#element").swipe("enable");
     */
    this.enable = function () {
      //Incase we are already enabled, clean up...
      this.disable();
      $element.bind(START_EV, touchStart);
      $element.bind(CANCEL_EV, touchCancel);
      return $element;
    };

    /**
     * disables the swipe plugin
     * @function
     * @name $.fn.swipe#disable
     * @return {DOMNode} The Dom element that is now registered with TouchSwipe
     * @example $("#element").swipe("disable");
     */
    this.disable = function () {
      removeListeners();
      return $element;
    };

    /**
     * Destroy the swipe plugin completely. To use any swipe methods, you must re initialise the plugin.
     * @function
     * @name $.fn.swipe#destroy
     * @example $("#element").swipe("destroy");
     */
    this.destroy = function () {
      removeListeners();
      $element.data(PLUGIN_NS, null);
      $element = null;
    };


    /**
     * Allows run time updating of the swipe configuration options.
     * @function
     * @name $.fn.swipe#option
     * @param {String} property The option property to get or set, or a has of multiple options to set
     * @param {Object} [value] The value to set the property to
     * @return {Object} If only a property name is passed, then that property value is returned. If nothing is passed the current options hash is returned.
     * @example $("#element").swipe("option", "threshold"); // return the threshold
     * @example $("#element").swipe("option", "threshold", 100); // set the threshold after init
     * @example $("#element").swipe("option", {threshold:100, fingers:3} ); // set multiple properties after init
     * @example $("#element").swipe({threshold:100, fingers:3} ); // set multiple properties after init - the "option" method is optional!
     * @example $("#element").swipe("option"); // Return the current options hash
     * @see $.fn.swipe.defaults
     *
     */
    this.option = function (property, value) {

      if (typeof property === 'object') {
        options = $.extend(options, property);
      } else if (options[property] !== undefined) {
        if (value === undefined) {
          return options[property];
        } else {
          options[property] = value;
        }
      } else if (!property) {
        return options;
      } else {
        $.error('Option ' + property + ' does not exist on jQuery.swipe.options');
      }

      return null;
    }



    //
    // Private methods
    //

    //
    // EVENTS
    //
    /**
     * Event handler for a touch start event.
     * Stops the default click event from triggering and stores where we touched
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchStart(jqEvent) {

      //If we already in a touch event (a finger already in use) then ignore subsequent ones..
      if (getTouchInProgress()) {
        return;
      }

      //Check if this element matches any in the excluded elements selectors,  or its parent is excluded, if so, DON'T swipe
      if ($(jqEvent.target).closest(options.excludedElements, $element).length > 0) {
        return;
      }

      //As we use Jquery bind for events, we need to target the original event object
      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;


      //If we have a pointer event, whoes type is 'mouse' and we have said NO mouse events, then dont do anything.
      if (event.pointerType && event.pointerType == "mouse" && options.fallbackToMouseEvents == false) {
        return;
      };

      var ret,
        touches = event.touches,
        evt = touches ? touches[0] : event;

      phase = PHASE_START;

      //If we support touches, get the finger count
      if (touches) {
        // get the total number of fingers touching the screen
        fingerCount = touches.length;
      }
      //Else this is the desktop, so stop the browser from dragging content
      else if (options.preventDefaultEvents !== false) {
        jqEvent.preventDefault(); //call this on jq event so we are cross browser
      }

      //clear vars..
      distance = 0;
      direction = null;
      currentDirection = null;
      pinchDirection = null;
      duration = 0;
      startTouchesDistance = 0;
      endTouchesDistance = 0;
      pinchZoom = 1;
      pinchDistance = 0;
      maximumsMap = createMaximumsData();
      cancelMultiFingerRelease();

      //Create the default finger data
      createFingerData(0, evt);

      // check the number of fingers is what we are looking for, or we are capturing pinches
      if (!touches || (fingerCount === options.fingers || options.fingers === ALL_FINGERS) || hasPinches()) {
        // get the coordinates of the touch
        startTime = getTimeStamp();

        if (fingerCount == 2) {
          //Keep track of the initial pinch distance, so we can calculate the diff later
          //Store second finger data as start
          createFingerData(1, touches[1]);
          startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
        }

        if (options.swipeStatus || options.pinchStatus) {
          ret = triggerHandler(event, phase);
        }
      } else {
        //A touch with more or less than the fingers we are looking for, so cancel
        ret = false;
      }

      //If we have a return value from the users handler, then return and cancel
      if (ret === false) {
        phase = PHASE_CANCEL;
        triggerHandler(event, phase);
        return ret;
      } else {
        if (options.hold) {
          holdTimeout = setTimeout($.proxy(function () {
            //Trigger the event
            $element.trigger('hold', [event.target]);
            //Fire the callback
            if (options.hold) {
              ret = options.hold.call($element, event, event.target);
            }
          }, this), options.longTapThreshold);
        }

        setTouchInProgress(true);
      }

      return null;
    };



    /**
     * Event handler for a touch move event.
     * If we change fingers during move, then cancel the event
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchMove(jqEvent) {

      //As we use Jquery bind for events, we need to target the original event object
      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

      //If we are ending, cancelling, or within the threshold of 2 fingers being released, don't track anything..
      if (phase === PHASE_END || phase === PHASE_CANCEL || inMultiFingerRelease())
        return;

      var ret,
        touches = event.touches,
        evt = touches ? touches[0] : event;


      //Update the  finger data
      var currentFinger = updateFingerData(evt);
      endTime = getTimeStamp();

      if (touches) {
        fingerCount = touches.length;
      }

      if (options.hold) {
        clearTimeout(holdTimeout);
      }

      phase = PHASE_MOVE;

      //If we have 2 fingers get Touches distance as well
      if (fingerCount == 2) {

        //Keep track of the initial pinch distance, so we can calculate the diff later
        //We do this here as well as the start event, in case they start with 1 finger, and the press 2 fingers
        if (startTouchesDistance == 0) {
          //Create second finger if this is the first time...
          createFingerData(1, touches[1]);

          startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
        } else {
          //Else just update the second finger
          updateFingerData(touches[1]);

          endTouchesDistance = calculateTouchesDistance(fingerData[0].end, fingerData[1].end);
          pinchDirection = calculatePinchDirection(fingerData[0].end, fingerData[1].end);
        }

        pinchZoom = calculatePinchZoom(startTouchesDistance, endTouchesDistance);
        pinchDistance = Math.abs(startTouchesDistance - endTouchesDistance);
      }

      if ((fingerCount === options.fingers || options.fingers === ALL_FINGERS) || !touches || hasPinches()) {

        //The overall direction of the swipe. From start to now.
        direction = calculateDirection(currentFinger.start, currentFinger.end);

        //The immediate direction of the swipe, direction between the last movement and this one.
        currentDirection = calculateDirection(currentFinger.last, currentFinger.end);

        //Check if we need to prevent default event (page scroll / pinch zoom) or not
        validateDefaultEvent(jqEvent, currentDirection);

        //Distance and duration are all off the main finger
        distance = calculateDistance(currentFinger.start, currentFinger.end);
        duration = calculateDuration();

        //Cache the maximum distance we made in this direction
        setMaxDistance(direction, distance);

        //Trigger status handler
        ret = triggerHandler(event, phase);


        //If we trigger end events when threshold are met, or trigger events when touch leaves element
        if (!options.triggerOnTouchEnd || options.triggerOnTouchLeave) {

          var inBounds = true;

          //If checking if we leave the element, run the bounds check (we can use touchleave as its not supported on webkit)
          if (options.triggerOnTouchLeave) {
            var bounds = getbounds(this);
            inBounds = isInBounds(currentFinger.end, bounds);
          }

          //Trigger end handles as we swipe if thresholds met or if we have left the element if the user has asked to check these..
          if (!options.triggerOnTouchEnd && inBounds) {
            phase = getNextPhase(PHASE_MOVE);
          }
          //We end if out of bounds here, so set current phase to END, and check if its modified
          else if (options.triggerOnTouchLeave && !inBounds) {
            phase = getNextPhase(PHASE_END);
          }

          if (phase == PHASE_CANCEL || phase == PHASE_END) {
            triggerHandler(event, phase);
          }
        }
      } else {
        phase = PHASE_CANCEL;
        triggerHandler(event, phase);
      }

      if (ret === false) {
        phase = PHASE_CANCEL;
        triggerHandler(event, phase);
      }
    }




    /**
     * Event handler for a touch end event.
     * Calculate the direction and trigger events
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchEnd(jqEvent) {
      //As we use Jquery bind for events, we need to target the original event object
      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent,
        touches = event.touches;

      //If we are still in a touch with the device wait a fraction and see if the other finger comes up
      //if it does within the threshold, then we treat it as a multi release, not a single release and end the touch / swipe
      if (touches) {
        if (touches.length && !inMultiFingerRelease()) {
          startMultiFingerRelease(event);
          return true;
        } else if (touches.length && inMultiFingerRelease()) {
          return true;
        }
      }

      //If a previous finger has been released, check how long ago, if within the threshold, then assume it was a multifinger release.
      //This is used to allow 2 fingers to release fractionally after each other, whilst maintaining the event as containing 2 fingers, not 1
      if (inMultiFingerRelease()) {
        fingerCount = fingerCountAtRelease;
      }

      //Set end of swipe
      endTime = getTimeStamp();

      //Get duration incase move was never fired
      duration = calculateDuration();

      //If we trigger handlers at end of swipe OR, we trigger during, but they didnt trigger and we are still in the move phase
      if (didSwipeBackToCancel() || !validateSwipeDistance()) {
        phase = PHASE_CANCEL;
        triggerHandler(event, phase);
      } else if (options.triggerOnTouchEnd || (options.triggerOnTouchEnd === false && phase === PHASE_MOVE)) {
        //call this on jq event so we are cross browser
        if (options.preventDefaultEvents !== false) {
          jqEvent.preventDefault();
        }
        phase = PHASE_END;
        triggerHandler(event, phase);
      }
      //Special cases - A tap should always fire on touch end regardless,
      //So here we manually trigger the tap end handler by itself
      //We dont run trigger handler as it will re-trigger events that may have fired already
      else if (!options.triggerOnTouchEnd && hasTap()) {
        //Trigger the pinch events...
        phase = PHASE_END;
        triggerHandlerForGesture(event, phase, TAP);
      } else if (phase === PHASE_MOVE) {
        phase = PHASE_CANCEL;
        triggerHandler(event, phase);
      }

      setTouchInProgress(false);

      return null;
    }



    /**
     * Event handler for a touch cancel event.
     * Clears current vars
     * @inner
     */
    function touchCancel() {
      // reset the variables back to default values
      fingerCount = 0;
      endTime = 0;
      startTime = 0;
      startTouchesDistance = 0;
      endTouchesDistance = 0;
      pinchZoom = 1;

      //If we were in progress of tracking a possible multi touch end, then re set it.
      cancelMultiFingerRelease();

      setTouchInProgress(false);
    }


    /**
     * Event handler for a touch leave event.
     * This is only triggered on desktops, in touch we work this out manually
     * as the touchleave event is not supported in webkit
     * @inner
     */
    function touchLeave(jqEvent) {
      //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
      var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

      //If we have the trigger on leave property set....
      if (options.triggerOnTouchLeave) {
        phase = getNextPhase(PHASE_END);
        triggerHandler(event, phase);
      }
    }

    /**
     * Removes all listeners that were associated with the plugin
     * @inner
     */
    function removeListeners() {
      $element.unbind(START_EV, touchStart);
      $element.unbind(CANCEL_EV, touchCancel);
      $element.unbind(MOVE_EV, touchMove);
      $element.unbind(END_EV, touchEnd);

      //we only have leave events on desktop, we manually calculate leave on touch as its not supported in webkit
      if (LEAVE_EV) {
        $element.unbind(LEAVE_EV, touchLeave);
      }

      setTouchInProgress(false);
    }


    /**
     * Checks if the time and distance thresholds have been met, and if so then the appropriate handlers are fired.
     */
    function getNextPhase(currentPhase) {

      var nextPhase = currentPhase;

      // Ensure we have valid swipe (under time and over distance  and check if we are out of bound...)
      var validTime = validateSwipeTime();
      var validDistance = validateSwipeDistance();
      var didCancel = didSwipeBackToCancel();

      //If we have exceeded our time, then cancel
      if (!validTime || didCancel) {
        nextPhase = PHASE_CANCEL;
      }
      //Else if we are moving, and have reached distance then end
      else if (validDistance && currentPhase == PHASE_MOVE && (!options.triggerOnTouchEnd || options.triggerOnTouchLeave)) {
        nextPhase = PHASE_END;
      }
      //Else if we have ended by leaving and didn't reach distance, then cancel
      else if (!validDistance && currentPhase == PHASE_END && options.triggerOnTouchLeave) {
        nextPhase = PHASE_CANCEL;
      }

      return nextPhase;
    }


    /**
     * Trigger the relevant event handler
     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
     * @param {object} event the original event object
     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
     * @inner
     */
    function triggerHandler(event, phase) {



      var ret,
        touches = event.touches;

      // SWIPE GESTURES
      if (didSwipe() || hasSwipes()) {
        ret = triggerHandlerForGesture(event, phase, SWIPE);
      }

      // PINCH GESTURES (if the above didn't cancel)
      if ((didPinch() || hasPinches()) && ret !== false) {
        ret = triggerHandlerForGesture(event, phase, PINCH);
      }

      // CLICK / TAP (if the above didn't cancel)
      if (didDoubleTap() && ret !== false) {
        //Trigger the tap events...
        ret = triggerHandlerForGesture(event, phase, DOUBLE_TAP);
      }

      // CLICK / TAP (if the above didn't cancel)
      else if (didLongTap() && ret !== false) {
        //Trigger the tap events...
        ret = triggerHandlerForGesture(event, phase, LONG_TAP);
      }

      // CLICK / TAP (if the above didn't cancel)
      else if (didTap() && ret !== false) {
        //Trigger the tap event..
        ret = triggerHandlerForGesture(event, phase, TAP);
      }



      // If we are cancelling the gesture, then manually trigger the reset handler
      if (phase === PHASE_CANCEL) {

        touchCancel(event);
      }




      // If we are ending the gesture, then manually trigger the reset handler IF all fingers are off
      if (phase === PHASE_END) {
        //If we support touch, then check that all fingers are off before we cancel
        if (touches) {
          if (!touches.length) {
            touchCancel(event);
          }
        } else {
          touchCancel(event);
        }
      }

      return ret;
    }



    /**
     * Trigger the relevant event handler
     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
     * @param {object} event the original event object
     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
     * @param {string} gesture the gesture to trigger a handler for : PINCH or SWIPE {@link $.fn.swipe.gestures}
     * @return Boolean False, to indicate that the event should stop propagation, or void.
     * @inner
     */
    function triggerHandlerForGesture(event, phase, gesture) {

      var ret;

      //SWIPES....
      if (gesture == SWIPE) {
        //Trigger status every time..
        $element.trigger('swipeStatus', [phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection]);

        if (options.swipeStatus) {
          ret = options.swipeStatus.call($element, event, phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection);
          //If the status cancels, then dont run the subsequent event handlers..
          if (ret === false) return false;
        }

        if (phase == PHASE_END && validateSwipe()) {

          //Cancel any taps that were in progress...
          clearTimeout(singleTapTimeout);
          clearTimeout(holdTimeout);

          $element.trigger('swipe', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

          if (options.swipe) {
            ret = options.swipe.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
            //If the status cancels, then dont run the subsequent event handlers..
            if (ret === false) return false;
          }

          //trigger direction specific event handlers
          switch (direction) {
            case LEFT:
              $element.trigger('swipeLeft', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

              if (options.swipeLeft) {
                ret = options.swipeLeft.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
              }
              break;

            case RIGHT:
              $element.trigger('swipeRight', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

              if (options.swipeRight) {
                ret = options.swipeRight.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
              }
              break;

            case UP:
              $element.trigger('swipeUp', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

              if (options.swipeUp) {
                ret = options.swipeUp.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
              }
              break;

            case DOWN:
              $element.trigger('swipeDown', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

              if (options.swipeDown) {
                ret = options.swipeDown.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
              }
              break;
          }
        }
      }


      //PINCHES....
      if (gesture == PINCH) {
        $element.trigger('pinchStatus', [phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

        if (options.pinchStatus) {
          ret = options.pinchStatus.call($element, event, phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
          //If the status cancels, then dont run the subsequent event handlers..
          if (ret === false) return false;
        }

        if (phase == PHASE_END && validatePinch()) {

          switch (pinchDirection) {
            case IN:
              $element.trigger('pinchIn', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

              if (options.pinchIn) {
                ret = options.pinchIn.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
              }
              break;

            case OUT:
              $element.trigger('pinchOut', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

              if (options.pinchOut) {
                ret = options.pinchOut.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
              }
              break;
          }
        }
      }

      if (gesture == TAP) {
        if (phase === PHASE_CANCEL || phase === PHASE_END) {

          clearTimeout(singleTapTimeout);
          clearTimeout(holdTimeout);

          //If we are also looking for doubelTaps, wait incase this is one...
          if (hasDoubleTap() && !inDoubleTap()) {
            doubleTapStartTime = getTimeStamp();

            //Now wait for the double tap timeout, and trigger this single tap
            //if its not cancelled by a double tap
            singleTapTimeout = setTimeout($.proxy(function () {
              doubleTapStartTime = null;
              $element.trigger('tap', [event.target]);

              if (options.tap) {
                ret = options.tap.call($element, event, event.target);
              }
            }, this), options.doubleTapThreshold);

          } else {
            doubleTapStartTime = null;
            $element.trigger('tap', [event.target]);
            if (options.tap) {
              ret = options.tap.call($element, event, event.target);
            }
          }
        }
      } else if (gesture == DOUBLE_TAP) {
        if (phase === PHASE_CANCEL || phase === PHASE_END) {
          clearTimeout(singleTapTimeout);
          clearTimeout(holdTimeout);
          doubleTapStartTime = null;
          $element.trigger('doubletap', [event.target]);

          if (options.doubleTap) {
            ret = options.doubleTap.call($element, event, event.target);
          }
        }
      } else if (gesture == LONG_TAP) {
        if (phase === PHASE_CANCEL || phase === PHASE_END) {
          clearTimeout(singleTapTimeout);
          doubleTapStartTime = null;

          $element.trigger('longtap', [event.target]);
          if (options.longTap) {
            ret = options.longTap.call($element, event, event.target);
          }
        }
      }

      return ret;
    }


    //
    // GESTURE VALIDATION
    //

    /**
     * Checks the user has swipe far enough
     * @return Boolean if <code>threshold</code> has been set, return true if the threshold was met, else false.
     * If no threshold was set, then we return true.
     * @inner
     */
    function validateSwipeDistance() {
      var valid = true;
      //If we made it past the min swipe distance..
      if (options.threshold !== null) {
        valid = distance >= options.threshold;
      }

      return valid;
    }

    /**
     * Checks the user has swiped back to cancel.
     * @return Boolean if <code>cancelThreshold</code> has been set, return true if the cancelThreshold was met, else false.
     * If no cancelThreshold was set, then we return true.
     * @inner
     */
    function didSwipeBackToCancel() {
      var cancelled = false;
      if (options.cancelThreshold !== null && direction !== null) {
        cancelled = (getMaxDistance(direction) - distance) >= options.cancelThreshold;
      }

      return cancelled;
    }

    /**
     * Checks the user has pinched far enough
     * @return Boolean if <code>pinchThreshold</code> has been set, return true if the threshold was met, else false.
     * If no threshold was set, then we return true.
     * @inner
     */
    function validatePinchDistance() {
      if (options.pinchThreshold !== null) {
        return pinchDistance >= options.pinchThreshold;
      }
      return true;
    }

    /**
     * Checks that the time taken to swipe meets the minimum / maximum requirements
     * @return Boolean
     * @inner
     */
    function validateSwipeTime() {
      var result;
      //If no time set, then return true
      if (options.maxTimeThreshold) {
        if (duration >= options.maxTimeThreshold) {
          result = false;
        } else {
          result = true;
        }
      } else {
        result = true;
      }

      return result;
    }


    /**
     * Checks direction of the swipe and the value allowPageScroll to see if we should allow or prevent the default behaviour from occurring.
     * This will essentially allow page scrolling or not when the user is swiping on a touchSwipe object.
     * @param {object} jqEvent The normalised jQuery representation of the event object.
     * @param {string} direction The direction of the event. See {@link $.fn.swipe.directions}
     * @see $.fn.swipe.directions
     * @inner
     */
    function validateDefaultEvent(jqEvent, direction) {

      //If the option is set, allways allow the event to bubble up (let user handle weirdness)
      if (options.preventDefaultEvents === false) {
        return;
      }

      if (options.allowPageScroll === NONE) {
        jqEvent.preventDefault();
      } else {
        var auto = options.allowPageScroll === AUTO;

        switch (direction) {
          case LEFT:
            if ((options.swipeLeft && auto) || (!auto && options.allowPageScroll != HORIZONTAL)) {
              jqEvent.preventDefault();
            }
            break;

          case RIGHT:
            if ((options.swipeRight && auto) || (!auto && options.allowPageScroll != HORIZONTAL)) {
              jqEvent.preventDefault();
            }
            break;

          case UP:
            if ((options.swipeUp && auto) || (!auto && options.allowPageScroll != VERTICAL)) {
              jqEvent.preventDefault();
            }
            break;

          case DOWN:
            if ((options.swipeDown && auto) || (!auto && options.allowPageScroll != VERTICAL)) {
              jqEvent.preventDefault();
            }
            break;

          case NONE:

            break;
        }
      }
    }


    // PINCHES
    /**
     * Returns true of the current pinch meets the thresholds
     * @return Boolean
     * @inner
     */
    function validatePinch() {
      var hasCorrectFingerCount = validateFingers();
      var hasEndPoint = validateEndPoint();
      var hasCorrectDistance = validatePinchDistance();
      return hasCorrectFingerCount && hasEndPoint && hasCorrectDistance;

    }

    /**
     * Returns true if any Pinch events have been registered
     * @return Boolean
     * @inner
     */
    function hasPinches() {
      //Enure we dont return 0 or null for false values
      return !!(options.pinchStatus || options.pinchIn || options.pinchOut);
    }

    /**
     * Returns true if we are detecting pinches, and have one
     * @return Boolean
     * @inner
     */
    function didPinch() {
      //Enure we dont return 0 or null for false values
      return !!(validatePinch() && hasPinches());
    }




    // SWIPES
    /**
     * Returns true if the current swipe meets the thresholds
     * @return Boolean
     * @inner
     */
    function validateSwipe() {
      //Check validity of swipe
      var hasValidTime = validateSwipeTime();
      var hasValidDistance = validateSwipeDistance();
      var hasCorrectFingerCount = validateFingers();
      var hasEndPoint = validateEndPoint();
      var didCancel = didSwipeBackToCancel();

      // if the user swiped more than the minimum length, perform the appropriate action
      // hasValidDistance is null when no distance is set
      var valid = !didCancel && hasEndPoint && hasCorrectFingerCount && hasValidDistance && hasValidTime;

      return valid;
    }

    /**
     * Returns true if any Swipe events have been registered
     * @return Boolean
     * @inner
     */
    function hasSwipes() {
      //Enure we dont return 0 or null for false values
      return !!(options.swipe || options.swipeStatus || options.swipeLeft || options.swipeRight || options.swipeUp || options.swipeDown);
    }


    /**
     * Returns true if we are detecting swipes and have one
     * @return Boolean
     * @inner
     */
    function didSwipe() {
      //Enure we dont return 0 or null for false values
      return !!(validateSwipe() && hasSwipes());
    }

    /**
     * Returns true if we have matched the number of fingers we are looking for
     * @return Boolean
     * @inner
     */
    function validateFingers() {
      //The number of fingers we want were matched, or on desktop we ignore
      return ((fingerCount === options.fingers || options.fingers === ALL_FINGERS) || !SUPPORTS_TOUCH);
    }

    /**
     * Returns true if we have an end point for the swipe
     * @return Boolean
     * @inner
     */
    function validateEndPoint() {
      //We have an end value for the finger
      return fingerData[0].end.x !== 0;
    }

    // TAP / CLICK
    /**
     * Returns true if a click / tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasTap() {
      //Enure we dont return 0 or null for false values
      return !!(options.tap);
    }

    /**
     * Returns true if a double tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasDoubleTap() {
      //Enure we dont return 0 or null for false values
      return !!(options.doubleTap);
    }

    /**
     * Returns true if any long tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasLongTap() {
      //Enure we dont return 0 or null for false values
      return !!(options.longTap);
    }

    /**
     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
     * @return Boolean
     * @inner
     */
    function validateDoubleTap() {
      if (doubleTapStartTime == null) {
        return false;
      }
      var now = getTimeStamp();
      return (hasDoubleTap() && ((now - doubleTapStartTime) <= options.doubleTapThreshold));
    }

    /**
     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
     * @return Boolean
     * @inner
     */
    function inDoubleTap() {
      return validateDoubleTap();
    }


    /**
     * Returns true if we have a valid tap
     * @return Boolean
     * @inner
     */
    function validateTap() {
      return ((fingerCount === 1 || !SUPPORTS_TOUCH) && (isNaN(distance) || distance < options.threshold));
    }

    /**
     * Returns true if we have a valid long tap
     * @return Boolean
     * @inner
     */
    function validateLongTap() {
      //slight threshold on moving finger
      return ((duration > options.longTapThreshold) && (distance < DOUBLE_TAP_THRESHOLD));
    }

    /**
     * Returns true if we are detecting taps and have one
     * @return Boolean
     * @inner
     */
    function didTap() {
      //Enure we dont return 0 or null for false values
      return !!(validateTap() && hasTap());
    }


    /**
     * Returns true if we are detecting double taps and have one
     * @return Boolean
     * @inner
     */
    function didDoubleTap() {
      //Enure we dont return 0 or null for false values
      return !!(validateDoubleTap() && hasDoubleTap());
    }

    /**
     * Returns true if we are detecting long taps and have one
     * @return Boolean
     * @inner
     */
    function didLongTap() {
      //Enure we dont return 0 or null for false values
      return !!(validateLongTap() && hasLongTap());
    }




    // MULTI FINGER TOUCH
    /**
     * Starts tracking the time between 2 finger releases, and keeps track of how many fingers we initially had up
     * @inner
     */
    function startMultiFingerRelease(event) {
      previousTouchEndTime = getTimeStamp();
      fingerCountAtRelease = event.touches.length + 1;
    }

    /**
     * Cancels the tracking of time between 2 finger releases, and resets counters
     * @inner
     */
    function cancelMultiFingerRelease() {
      previousTouchEndTime = 0;
      fingerCountAtRelease = 0;
    }

    /**
     * Checks if we are in the threshold between 2 fingers being released
     * @return Boolean
     * @inner
     */
    function inMultiFingerRelease() {

      var withinThreshold = false;

      if (previousTouchEndTime) {
        var diff = getTimeStamp() - previousTouchEndTime
        if (diff <= options.fingerReleaseThreshold) {
          withinThreshold = true;
        }
      }

      return withinThreshold;
    }


    /**
     * gets a data flag to indicate that a touch is in progress
     * @return Boolean
     * @inner
     */
    function getTouchInProgress() {
      //strict equality to ensure only true and false are returned
      return !!($element.data(PLUGIN_NS + '_intouch') === true);
    }

    /**
     * Sets a data flag to indicate that a touch is in progress
     * @param {boolean} val The value to set the property to
     * @inner
     */
    function setTouchInProgress(val) {

      //If destroy is called in an event handler, we have no el, and we have already cleaned up, so return.
      if (!$element) { return; }

      //Add or remove event listeners depending on touch status
      if (val === true) {
        $element.bind(MOVE_EV, touchMove);
        $element.bind(END_EV, touchEnd);

        //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
        if (LEAVE_EV) {
          $element.bind(LEAVE_EV, touchLeave);
        }
      } else {

        $element.unbind(MOVE_EV, touchMove, false);
        $element.unbind(END_EV, touchEnd, false);

        //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
        if (LEAVE_EV) {
          $element.unbind(LEAVE_EV, touchLeave, false);
        }
      }


      //strict equality to ensure only true and false can update the value
      $element.data(PLUGIN_NS + '_intouch', val === true);
    }


    /**
     * Creates the finger data for the touch/finger in the event object.
     * @param {int} id The id to store the finger data under (usually the order the fingers were pressed)
     * @param {object} evt The event object containing finger data
     * @return finger data object
     * @inner
     */
    function createFingerData(id, evt) {
      var f = {
        start: {
          x: 0,
          y: 0
        },
        last: {
          x: 0,
          y: 0
        },
        end: {
          x: 0,
          y: 0
        }
      };
      f.start.x = f.last.x = f.end.x = evt.pageX || evt.clientX;
      f.start.y = f.last.y = f.end.y = evt.pageY || evt.clientY;
      fingerData[id] = f;
      return f;
    }

    /**
     * Updates the finger data for a particular event object
     * @param {object} evt The event object containing the touch/finger data to upadte
     * @return a finger data object.
     * @inner
     */
    function updateFingerData(evt) {
      var id = evt.identifier !== undefined ? evt.identifier : 0;
      var f = getFingerData(id);

      if (f === null) {
        f = createFingerData(id, evt);
      }

      f.last.x = f.end.x;
      f.last.y = f.end.y;

      f.end.x = evt.pageX || evt.clientX;
      f.end.y = evt.pageY || evt.clientY;

      return f;
    }

    /**
     * Returns a finger data object by its event ID.
     * Each touch event has an identifier property, which is used
     * to track repeat touches
     * @param {int} id The unique id of the finger in the sequence of touch events.
     * @return a finger data object.
     * @inner
     */
    function getFingerData(id) {
      return fingerData[id] || null;
    }


    /**
     * Sets the maximum distance swiped in the given direction.
     * If the new value is lower than the current value, the max value is not changed.
     * @param {string}  direction The direction of the swipe
     * @param {int}  distance The distance of the swipe
     * @inner
     */
    function setMaxDistance(direction, distance) {
      if (direction == NONE) return;
      distance = Math.max(distance, getMaxDistance(direction));
      maximumsMap[direction].distance = distance;
    }

    /**
     * gets the maximum distance swiped in the given direction.
     * @param {string}  direction The direction of the swipe
     * @return int  The distance of the swipe
     * @inner
     */
    function getMaxDistance(direction) {
      if (maximumsMap[direction]) return maximumsMap[direction].distance;
      return undefined;
    }

    /**
     * Creats a map of directions to maximum swiped values.
     * @return Object A dictionary of maximum values, indexed by direction.
     * @inner
     */
    function createMaximumsData() {
      var maxData = {};
      maxData[LEFT] = createMaximumVO(LEFT);
      maxData[RIGHT] = createMaximumVO(RIGHT);
      maxData[UP] = createMaximumVO(UP);
      maxData[DOWN] = createMaximumVO(DOWN);

      return maxData;
    }

    /**
     * Creates a map maximum swiped values for a given swipe direction
     * @param {string} The direction that these values will be associated with
     * @return Object Maximum values
     * @inner
     */
    function createMaximumVO(dir) {
      return {
        direction: dir,
        distance: 0
      }
    }


    //
    // MATHS / UTILS
    //

    /**
     * Calculate the duration of the swipe
     * @return int
     * @inner
     */
    function calculateDuration() {
      return endTime - startTime;
    }

    /**
     * Calculate the distance between 2 touches (pinch)
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int;
     * @inner
     */
    function calculateTouchesDistance(startPoint, endPoint) {
      var diffX = Math.abs(startPoint.x - endPoint.x);
      var diffY = Math.abs(startPoint.y - endPoint.y);

      return Math.round(Math.sqrt(diffX * diffX + diffY * diffY));
    }

    /**
     * Calculate the zoom factor between the start and end distances
     * @param {int} startDistance Distance (between 2 fingers) the user started pinching at
     * @param {int} endDistance Distance (between 2 fingers) the user ended pinching at
     * @return float The zoom value from 0 to 1.
     * @inner
     */
    function calculatePinchZoom(startDistance, endDistance) {
      var percent = (endDistance / startDistance) * 1;
      return percent.toFixed(2);
    }


    /**
     * Returns the pinch direction, either IN or OUT for the given points
     * @return string Either {@link $.fn.swipe.directions.IN} or {@link $.fn.swipe.directions.OUT}
     * @see $.fn.swipe.directions
     * @inner
     */
    function calculatePinchDirection() {
      if (pinchZoom < 1) {
        return OUT;
      } else {
        return IN;
      }
    }


    /**
     * Calculate the length / distance of the swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int
     * @inner
     */
    function calculateDistance(startPoint, endPoint) {
      return Math.round(Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2)));
    }

    /**
     * Calculate the angle of the swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int
     * @inner
     */
    function calculateAngle(startPoint, endPoint) {
      var x = startPoint.x - endPoint.x;
      var y = endPoint.y - startPoint.y;
      var r = Math.atan2(y, x); //radians
      var angle = Math.round(r * 180 / Math.PI); //degrees

      //ensure value is positive
      if (angle < 0) {
        angle = 360 - Math.abs(angle);
      }

      return angle;
    }

    /**
     * Calculate the direction of the swipe
     * This will also call calculateAngle to get the latest angle of swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return string Either {@link $.fn.swipe.directions.LEFT} / {@link $.fn.swipe.directions.RIGHT} / {@link $.fn.swipe.directions.DOWN} / {@link $.fn.swipe.directions.UP}
     * @see $.fn.swipe.directions
     * @inner
     */
    function calculateDirection(startPoint, endPoint) {

      if (comparePoints(startPoint, endPoint)) {
        return NONE;
      }

      var angle = calculateAngle(startPoint, endPoint);

      if ((angle <= 45) && (angle >= 0)) {
        return LEFT;
      } else if ((angle <= 360) && (angle >= 315)) {
        return LEFT;
      } else if ((angle >= 135) && (angle <= 225)) {
        return RIGHT;
      } else if ((angle > 45) && (angle < 135)) {
        return DOWN;
      } else {
        return UP;
      }
    }


    /**
     * Returns a MS time stamp of the current time
     * @return int
     * @inner
     */
    function getTimeStamp() {
      var now = new Date();
      return now.getTime();
    }



    /**
     * Returns a bounds object with left, right, top and bottom properties for the element specified.
     * @param {DomNode} The DOM node to get the bounds for.
     */
    function getbounds(el) {
      el = $(el);
      var offset = el.offset();

      var bounds = {
        left: offset.left,
        right: offset.left + el.outerWidth(),
        top: offset.top,
        bottom: offset.top + el.outerHeight()
      }

      return bounds;
    }


    /**
     * Checks if the point object is in the bounds object.
     * @param {object} point A point object.
     * @param {int} point.x The x value of the point.
     * @param {int} point.y The x value of the point.
     * @param {object} bounds The bounds object to test
     * @param {int} bounds.left The leftmost value
     * @param {int} bounds.right The righttmost value
     * @param {int} bounds.top The topmost value
     * @param {int} bounds.bottom The bottommost value
     */
    function isInBounds(point, bounds) {
      return (point.x > bounds.left && point.x < bounds.right && point.y > bounds.top && point.y < bounds.bottom);
    };

    /**
     * Checks if the two points are equal
     * @param {object} point A point object.
     * @param {object} point B point object.
     * @return true of the points match
     */
    function comparePoints(pointA, pointB) {
      return (pointA.x == pointB.x && pointA.y == pointB.y);
    }


  }




  /**
   * A catch all handler that is triggered for all swipe directions.
   * @name $.fn.swipe#swipe
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user swiped
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {object} fingerData The coordinates of fingers in event
   * @param {string} currentDirection The current direction the user is swiping.
   */




  /**
   * A handler that is triggered for "left" swipes.
   * @name $.fn.swipe#swipeLeft
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user swiped
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {object} fingerData The coordinates of fingers in event
   * @param {string} currentDirection The current direction the user is swiping.
   */

  /**
   * A handler that is triggered for "right" swipes.
   * @name $.fn.swipe#swipeRight
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user swiped
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {object} fingerData The coordinates of fingers in event
   * @param {string} currentDirection The current direction the user is swiping.
   */

  /**
   * A handler that is triggered for "up" swipes.
   * @name $.fn.swipe#swipeUp
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user swiped
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {object} fingerData The coordinates of fingers in event
   * @param {string} currentDirection The current direction the user is swiping.
   */

  /**
   * A handler that is triggered for "down" swipes.
   * @name $.fn.swipe#swipeDown
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user swiped
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {object} fingerData The coordinates of fingers in event
   * @param {string} currentDirection The current direction the user is swiping.
   */

  /**
   * A handler triggered for every phase of the swipe. This handler is constantly fired for the duration of the pinch.
   * This is triggered regardless of swipe thresholds.
   * @name $.fn.swipe#swipeStatus
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {string} phase The phase of the swipe event. See {@link $.fn.swipe.phases}
   * @param {string} direction The direction the user swiped in. This is null if the user has yet to move. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user swiped. This is 0 if the user has yet to move.
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {object} fingerData The coordinates of fingers in event
   * @param {string} currentDirection The current direction the user is swiping.
   */

  /**
   * A handler triggered for pinch in events.
   * @name $.fn.swipe#pinchIn
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user pinched
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
   * @param {object} fingerData The coordinates of fingers in event
   */

  /**
   * A handler triggered for pinch out events.
   * @name $.fn.swipe#pinchOut
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user pinched
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
   * @param {object} fingerData The coordinates of fingers in event
   */

  /**
   * A handler triggered for all pinch events. This handler is constantly fired for the duration of the pinch. This is triggered regardless of thresholds.
   * @name $.fn.swipe#pinchStatus
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
   * @param {int} distance The distance the user pinched
   * @param {int} duration The duration of the swipe in milliseconds
   * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
   * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
   * @param {object} fingerData The coordinates of fingers in event
   */

  /**
   * A click handler triggered when a user simply clicks, rather than swipes on an element.
   * This is deprecated since version 1.6.2, any assignment to click will be assigned to the tap handler.
   * You cannot use <code>on</code> to bind to this event as the default jQ <code>click</code> event will be triggered.
   * Use the <code>tap</code> event instead.
   * @name $.fn.swipe#click
   * @event
   * @deprecated since version 1.6.2, please use {@link $.fn.swipe#tap} instead
   * @default null
   * @param {EventObject} event The original event object
   * @param {DomObject} target The element clicked on.
   */

  /**
   * A click / tap handler triggered when a user simply clicks or taps, rather than swipes on an element.
   * @name $.fn.swipe#tap
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {DomObject} target The element clicked on.
   */

  /**
   * A double tap handler triggered when a user double clicks or taps on an element.
   * You can set the time delay for a double tap with the {@link $.fn.swipe.defaults#doubleTapThreshold} property.
   * Note: If you set both <code>doubleTap</code> and <code>tap</code> handlers, the <code>tap</code> event will be delayed by the <code>doubleTapThreshold</code>
   * as the script needs to check if its a double tap.
   * @name $.fn.swipe#doubleTap
   * @see  $.fn.swipe.defaults#doubleTapThreshold
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {DomObject} target The element clicked on.
   */

  /**
   * A long tap handler triggered once a tap has been release if the tap was longer than the longTapThreshold.
   * You can set the time delay for a long tap with the {@link $.fn.swipe.defaults#longTapThreshold} property.
   * @name $.fn.swipe#longTap
   * @see  $.fn.swipe.defaults#longTapThreshold
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {DomObject} target The element clicked on.
   */

  /**
   * A hold tap handler triggered as soon as the longTapThreshold is reached
   * You can set the time delay for a long tap with the {@link $.fn.swipe.defaults#longTapThreshold} property.
   * @name $.fn.swipe#hold
   * @see  $.fn.swipe.defaults#longTapThreshold
   * @event
   * @default null
   * @param {EventObject} event The original event object
   * @param {DomObject} target The element clicked on.
   */

}));













/*!
	* Lightbox v2.9.0
	* by Lokesh Dhakar
	*
	* More info:
	* http://lokeshdhakar.com/projects/lightbox2/
	*
	* Copyright 2007, 2015 Lokesh Dhakar
	* Released under the MIT license
	* https://github.com/lokesh/lightbox2/blob/master/LICENSE
	*
	* @preserve
*/



// Uses Node, AMD or browser globals to create a module.
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals (root is window)
    root.lightbox = factory(root.jQuery);
  }
}(this, function ($) {

  function Lightbox(options) {
    this.album = [];
    this.currentImageIndex = void 0;
    this.init();

    // options
    this.options = $.extend({}, this.constructor.defaults);
    this.option(options);
  }

  // Descriptions of all options available on the demo site:
  // http://lokeshdhakar.com/projects/lightbox2/index.html#options
  Lightbox.defaults = {
    albumLabel: ' (%1 of %2) ',
    imageFadeDuration: 300
  };

  Lightbox.prototype.option = function (options) {
    $.extend(this.options, options);
  };

  Lightbox.prototype.imageCountLabel = function (currentImageNum, totalImages) {
    return this.options.albumLabel.replace(/%1/g, currentImageNum).replace(/%2/g, totalImages);
  };

  Lightbox.prototype.init = function () {
    var self = this;
    // Both enable and build methods require the body tag to be in the DOM.
    $(document).ready(function () {
      self.enable();
      self.build();
    });
  };

  // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
  // that contain 'lightbox'. When these are clicked, start lightbox.
  Lightbox.prototype.enable = function () {
    var self = this;
    $('body').on('click', 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function (event) {
      self.start($(event.currentTarget));
      return false;
    });
  };

  // Build html for the lightbox and the overlay.
  // Attach event handlers to the new DOM elements. click click click
  Lightbox.prototype.build = function () {
    var self = this;

    $('<div id="lightboxBackground" style="display:none;"><div class="lb-loadingWrapper"><i class="fa-fw fas fa-spinner fa-spin"></i></div></div><div id="lightbox" style="display:none;"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="/><div class="lb-loadingErrorMessage"><i class="fa-fw far fa-frown"></i>Sorry, that image did not load</div><div class="lb-description"><span class="lb-caption"></span><span class="lb-number"></span></div><a class="lb-prev"><div class="lb-iconWrapper"><i class="fas fa-fw fa-arrow-left"></i></div></a><a class="lb-next"><div class="lb-iconWrapper"><i class="fas fa-fw fa-arrow-right"></i></div></a><a class="lb-close"><div class="lb-iconWrapper"><i class="fas fa-fw fa-times"></i></div></a></div></div>').appendTo($('body'));




    // Cache jQuery objects
    this.$background = $('#lightboxBackground');
    this.$loading = this.$background.find('.lb-loadingWrapper');
    this.$lightbox = $('#lightbox');
    this.$container = this.$lightbox.find('.lb-container');
    this.$image = this.$lightbox.find('.lb-image');


    // Attach event handlers to the newly minted DOM elements
    this.$background.hide().on('click', function () {
      self.end();
      return false;
    });

    this.$lightbox.hide().on('click', function (event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });


    this.$lightbox.find('.lb-prev').on('click', function () {
      if (self.currentImageIndex === 0) {
        self.hideImage(self.album.length - 1);
      } else {
        self.hideImage(self.currentImageIndex - 1);
      }
      return false;
    });

    this.$lightbox.find('.lb-next').on('click', function () {
      if (self.currentImageIndex === self.album.length - 1) {
        self.hideImage(0);
      } else {
        self.hideImage(self.currentImageIndex + 1);
      }
      return false;
    });


    //add swipe support (added by phil 18th july 2018)
    // add swipe support
    $('#lightbox').swipe({
      swipeLeft: function (event, direction, distance, duration, fingerCount) {
        $('#lightbox a.lb-next').trigger('click');
      },
      swipeRight: function (event, direction, distance, duration, fingerCount) {
        $('#lightbox a.lb-prev').trigger('click');
      }
    });


    this.$lightbox.find('.lb-loader, .lb-close').on('click', function () {
      self.end();
      return false;
    });
  };

  // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
  Lightbox.prototype.start = function ($link) {
    var self = this;
    var $window = $(window);


    this.album = [];
    var imageNumber = 0;

    function addToAlbum($link) {
      self.album.push({
        // link: $link.attr('href'),
        link: getHrefOfImage($link),
        title: $link.attr('data-title') || $link.attr('title')
      });
    }

    function getHrefOfImage($link) {

      if (window.innerHeight > window.innerWidth) {

        // is portrait
        if ($link.attr('data-lightbox-portrait-option')) {
          return $link.attr('data-lightbox-portrait-option');
        } else {
          //default landscape option
          return $link.attr('href');
        }

      } else {
        // is landscape - default option				
        return $link.attr('href');
      }
    }

    // Support both data-lightbox attribute and rel attribute implementations
    var dataLightboxValue = $link.attr('data-lightbox');
    var $links;

    if (dataLightboxValue) {
      $links = $($link.prop('tagName') + '[data-lightbox="' + dataLightboxValue + '"]');
      for (var i = 0; i < $links.length; i = ++i) {
        addToAlbum($($links[i]));
        if ($links[i] === $link[0]) {
          imageNumber = i;
        }
      }
    } else {
      if ($link.attr('rel') === 'lightbox') {
        // If image is not part of a set
        addToAlbum($link);
      } else {
        // If image is part of a set
        $links = $($link.prop('tagName') + '[rel="' + $link.attr('rel') + '"]');
        for (var j = 0; j < $links.length; j = ++j) {
          addToAlbum($($links[j]));
          if ($links[j] === $link[0]) {
            imageNumber = j;
          }
        }
      }
    }


    this.$loading.show();

    this.$background.fadeIn(this.options.imageFadeDuration);

    this.changeImage(imageNumber);
  };

  // Hide then call change.
  Lightbox.prototype.hideImage = function (imageNumber) {
    var self = this;

    this.disableKeyboardNav();

    var obj = this;

    this.$lightbox.fadeOut(this.options.imageFadeDuration, function () {
      obj.changeImage(imageNumber)
    });

  };


  // change image, then call show
  Lightbox.prototype.changeImage = function (imageNumber) {

    var self = this;

    this.currentImageIndex = imageNumber;

    //update image overlays
    this.updateNav();
    this.updateDetails();

    this.preloadNeighboringImages();


    //Change Image
    var $image = this.$lightbox.find('.lb-image');
    $image.attr('src', self.album[imageNumber].link);


    //show loading. it will hide as soon as image is loaded
    this.$loading.delay(100).fadeIn(200);

    // 		
    var $objLightBox = this;
    var image = new Image();
    image.onload = function () {

      $objLightBox.$lightbox.removeClass('loadingError');
      $objLightBox.showImage();

    };

    //error loading image handler
    image.onerror = function () {

      if (window.aILogException)
        window.aILogException({
          exception: new Error(`Broken Image: ${image.src}`),
          properties: { 'href': window.location.href }
        });

      //Raven.captureException(new CustomizedError('Broken Image', "src: " + image.src));

      $objLightBox.$lightbox.addClass('loadingError');
      $objLightBox.showImage();

    };

    image.src = self.album[imageNumber].link;

  };


  //show the image
  Lightbox.prototype.showImage = function () {

    var self = this;

    //hide loader
    this.$loading.stop().hide();

    // fadein lightbox
    this.$lightbox.fadeIn(2 * this.options.imageFadeDuration);

    this.enableKeyboardNav();


  };







  // Display previous and next navigation if appropriate.
  Lightbox.prototype.updateNav = function () {

    //hide nav buttons, then turn on if required
    this.$lightbox.find('.lb-prev, .lb-next').hide();

    if (this.album.length > 1) {
      if (this.currentImageIndex > 0) {
        this.$lightbox.find('.lb-prev').show();
      }
      if (this.currentImageIndex < this.album.length - 1) {
        this.$lightbox.find('.lb-next').show();
      }
    }
  };

  // Display caption, image number, and closing button.
  Lightbox.prototype.updateDetails = function () {
    var self = this;

    // Enable anchor clicks in the injected caption html.
    // Thanks Nate Wright for the fix. @https://github.com/NateWr
    if (typeof this.album[this.currentImageIndex].title !== 'undefined' &&
      this.album[this.currentImageIndex].title !== '') {
      var $caption = this.$lightbox.find('.lb-caption');
      $caption.html(this.album[this.currentImageIndex].title);

      $caption.fadeIn('fast')
        .find('a').on('click', function (event) {
          if ($(this).attr('target') !== undefined) {
            window.open($(this).attr('href'), $(this).attr('target'));
          } else {
            location.href = $(this).attr('href');
          }
        });
    }

    if (this.album.length > 1) {
      var labelText = this.imageCountLabel(this.currentImageIndex + 1, this.album.length);
      this.$lightbox.find('.lb-number').text(labelText).fadeIn('fast');
    } else {
      this.$lightbox.find('.lb-number').hide();
    }
  };


  // Preload previous and next images in set.
  Lightbox.prototype.preloadNeighboringImages = function () {
    if (this.album.length > this.currentImageIndex + 1) {
      var preloadNext = new Image();
      preloadNext.src = this.album[this.currentImageIndex + 1].link;
    }
    if (this.currentImageIndex > 0) {
      var preloadPrev = new Image();
      preloadPrev.src = this.album[this.currentImageIndex - 1].link;
    }
  };

  //Keyboard Nav
  Lightbox.prototype.enableKeyboardNav = function () {
    $(document).on('keyup.keyboard', $.proxy(this.keyboardAction, this));
  };

  Lightbox.prototype.disableKeyboardNav = function () {
    $(document).off('.keyboard');
  };

  Lightbox.prototype.keyboardAction = function (event) {
    var KEYCODE_ESC = 27;
    var KEYCODE_LEFTARROW = 37;
    var KEYCODE_RIGHTARROW = 39;

    var keycode = event.keyCode;
    var key = String.fromCharCode(keycode).toLowerCase();
    if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
      this.end();
    } else if (key === 'p' || keycode === KEYCODE_LEFTARROW) {
      if (this.currentImageIndex !== 0) {
        this.hideImage(this.currentImageIndex - 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.hideImage(this.album.length - 1);
      }
    } else if (key === 'n' || keycode === KEYCODE_RIGHTARROW) {
      if (this.currentImageIndex !== this.album.length - 1) {
        this.hideImage(this.currentImageIndex + 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.hideImage(0);
      }
    }
  };

  // Closing time.
  Lightbox.prototype.end = function () {

    this.disableKeyboardNav();
    this.$loading.hide();
    this.$lightbox.fadeOut(this.options.imageFadeDuration);
    this.$background.fadeOut(this.options.imageFadeDuration);

  };

  return new Lightbox();
}));



 $(document).ready(function () {
	
	$('.googleMapWrapper')
		.click(function(){
			$(this).find('iframe').addClass('clicked')
		})
		.mouseleave(function(){
			$(this).find('iframe').removeClass('clicked')
		});
		
}); /* https://github.com/peledies/google-places */
(function($) {

    $.googlePlaces = function(element, options) {

        var defaults = {
              placeId: 'ChIJcVzImPWnjkcRCtIRiq35Chc' // placeId provided by google api documentation
            , render: ['reviews']
            , min_rating: 0
            , max_rows: 0
            , rotateTime: false
        };

        var plugin = this;

        plugin.settings = {}

        var $element = $(element),
             element = element;

        plugin.init = function() {
          plugin.settings = $.extend({}, defaults, options);
          $element.html("<div id='map-plug'></div>"); // create a plug for google to load data into
          initialize_place(function(place){
            plugin.place_data = place;
            // render specified sections
            if(plugin.settings.render.indexOf('reviews') > -1){
              renderReviews(plugin.place_data.reviews);
              if(!!plugin.settings.rotateTime) {
                  initRotation();
              }
            }
          });
        }

        var initialize_place = function(c){
          var map = new google.maps.Map(document.getElementById('map-plug'));

          var request = {
            placeId: plugin.settings.placeId
          };

          var service = new google.maps.places.PlacesService(map);

          service.getDetails(request, function(place, status) {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
              c(place);
            }
          });
        }

        var sort_by_date = function(ray) {
          ray.sort(function(a, b){
            var keyA = new Date(a.time),
            keyB = new Date(b.time);
            // Compare the 2 dates
            if(keyA < keyB) return -1;
            if(keyA > keyB) return 1;
            return 0;
          });
          return ray;
        }

        var filter_minimum_rating = function(reviews){
          for (var i = reviews.length -1; i >= 0; i--) {
            if(reviews[i].rating < plugin.settings.min_rating){
              reviews.splice(i,1);
            }
          }
          return reviews;
        }

        var renderReviews = function(reviews){
          reviews = sort_by_date(reviews);
          reviews = filter_minimum_rating(reviews);
          var html = "";
          var row_count = (plugin.settings.max_rows > 0)? plugin.settings.max_rows - 1 : reviews.length - 1;
          // make sure the row_count is not greater than available records
          row_count = (row_count > reviews.length-1)? reviews.length -1 : row_count;
          for (var i = row_count; i >= 0; i--) {
            var stars = renderStars(reviews[i].rating);
            var date = convertTime(reviews[i].time);
            html = html+"<div class='review-item'><div class='review-meta'><span class='review-author'>"+reviews[i].author_name+"</span><span class='review-sep'>, </span><span class='review-date'>"+date+"</span></div>"+stars+"<p class='review-text'>"+reviews[i].text+"</p></div>"
          };
          $element.append(html);
        }
        
        var initRotation = function() {
            var $reviewEls = $element.children('.review-item');
            var currentIdx = $reviewEls.length > 0 ? 0 : false;
            $reviewEls.hide();
            if(currentIdx !== false) {
                $($reviewEls[currentIdx]).show();
                setInterval(function(){ 
                    if(++currentIdx >= $reviewEls.length) {
                        currentIdx = 0;
                    }
                    $reviewEls.hide();
                    $($reviewEls[currentIdx]).fadeIn('slow');
                }, plugin.settings.rotateTime);
            }
        }

        var renderStars = function(rating){
          var stars = "<div class='review-stars'><ul>";
                            
          // fill in gold stars
          for (var i = 0; i < rating; i++) {
            stars = stars+"<li><i class='star'></i></li>";
          };

          // fill in empty stars
          if(rating < 5){
            for (var i = 0; i < (5 - rating); i++) {
              stars = stars+"<li><i class='star inactive'></i></li>";
            };
          }
          stars = stars+"</ul></div>";
          return stars;
        }

        var convertTime = function(UNIX_timestamp){
          var a = new Date(UNIX_timestamp * 1000);
          var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
          var time = months[a.getMonth()] + ' ' + a.getDate() + ', ' + a.getFullYear();
          return time;
        }

        plugin.init();

    }

    $.fn.googlePlaces = function(options) {

        return this.each(function() {
            if (undefined == $(this).data('googlePlaces')) {
                var plugin = new $.googlePlaces(this, options);
                $(this).data('googlePlaces', plugin);
            }
        });

    }

})(jQuery); $(document).ready(() => {
  let cookieDialogue$ = $("#cookieConsent");

  // If the consent dialogue exists, do all consent stuff.
  if (cookieDialogue$.length) {
    let acceptButton$ = $("#acceptCookies");
    let rejectButton$ = $("#rejectCookies");

    acceptButton$.click(function () {
      sendUserConsentToGoogleAnalytics(true);
      setCookie("user-consent", "granted");
      hideConsent();
    });

    rejectButton$.click(function () {
      sendUserConsentToGoogleAnalytics(false);

      // I can't store the user's choice in cookies, because he/she declined to do so. As a result, the user will be shown the consent dialogue on every load and every page!
      //setCookie("user-consent", "denied");

      hideConsent();
    });

    function buildCookieKey(name) {
      // Prefix the cookie name with the hostname. Include the port only for localhost
      // to avoid collisions when testing on localhost while keeping production keys stable.
      try {
        var host = window.location.hostname || '';
        var port = '';
        // Only include port when testing on localhost (or 127.0.0.1) to avoid splitting
        // cookies for normal production domains that use standard ports.
        if ((host === 'localhost' || host === '127.0.0.1') && window.location.port) {
          port = '-' + window.location.port;
        }
        return host + port + '-' + name;
      } catch (e) {
        // Fallback if window is not available for any reason
        return name;
      }
    }

    function setCookie(name, value) {
      var cookieKey = buildCookieKey(name);
      var expires = "";
      var date = new Date();
      // 10 years!
      date.setTime(date.getTime() + 3650 * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
      document.cookie = cookieKey + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get a cookie by name
    function getCookie(name) {
      var cookieKey = buildCookieKey(name) + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(cookieKey) == 0) return c.substring(cookieKey.length, c.length);
      }
      return null;
    }

    let hideConsent = () => {
      cookieDialogue$.removeClass("displayed");
    };

    /// Function to show the consent div if user is not given the consent yet.
    let showConsentDivIfNeeded = () => {
      var userConsent = getCookie("user-consent");
      if (userConsent === "granted" || userConsent === "denied") {
        // Respect the actual stored user choice: granted => true, denied => false
        sendUserConsentToGoogleAnalytics(userConsent === "granted");
        hideConsent();
      } else {
        cookieDialogue$.addClass("displayed");
      }
    };

    /// Function to send the user consent to Google Analytics.
    let sendUserConsentToGoogleAnalytics = (isGranted) => {
      let consent = isGranted ? "granted" : "denied";
      gtag("consent", "update", {
        ad_storage: consent,
        ad_user_data: consent,
        ad_personalization: consent,
        analytics_storage: consent,
        ad_user_data: consent,
        ad_personalization: consent,
      });
    };

    showConsentDivIfNeeded();
  }
});
 //Only do the below when the document is ready
$(document).ready(function () {
  // something is going to happen when there is a click on a ul.imgMapToggle which is a child of productSummaryBoxWrapper>div

  $(
    ".productSummaryBoxWrapper>div ul.imgMapToggle >li >span, .productSummaryBox ul.imgMapToggle >li >span"
  ).click(function () {
    // remove the class "selected" from the span which has been clicked
    $(this)
      .closest(".productSummaryBoxWrapper>div, .productSummaryBox")
      .find(".selected")
      .removeClass("selected");

    // add class "selected" to the span which was clicked
    $(this).addClass("selected");

    // find the name of the selector that was clicked
    var selectedOptionName = $(this).data("option");

    // add the appropriate class to the parent, depending on which image you want to see
    $(this)
      .closest(".productSummaryBoxWrapper>div, .productSummaryBox")
      .removeClass("showImage")
      .removeClass("showMap")
      .addClass(selectedOptionName);
  });

  //show options on click
  $(
    ".clForms-dropdown-single > div > div:first-child, .clForms-dropdown-multi > div > div:first-child"
  ).click(function (event) {
    var $chosenItem = $(event.target);

    //toggle showing options
    $chosenItem.parent().toggleClass("showOptions");
  });

  //Select and auto hide options
  $(".clForms-dropdown-single > div > ul > li").click(function (event) {
    var $optionClicked = $(event.target);

    //if child of li has been clicked then move up the DOM tree to the li
    if (!$optionClicked.is("li")) {
      $optionClicked = $optionClicked.closest("li");
    }

    //get text of selection
    var textSelected = $optionClicked.children("label").first().html();

    //hide the options
    $optionClicked.parent().parent().removeClass("showOptions");

    //update selected item
    $optionClicked.parent().siblings("div").first().html(textSelected);
  });

  //custom hide triggers
  //so in a website we can add other buttons that trigger closing action just by adding the below class
  $(".clForms-dropdown-close-all").click(function (event) {
    //hide any open dropdowns.
    $(
      ".clForms-dropdown-single > div, .clForms-dropdown-multi > div"
    ).removeClass("showOptions");
  });

  /////////////// tabs
  $(".tabSelectors>ul>li").click(function () {
    //Remove class "selected" from the tabs and the contents below
    $(this).closest(".tabs").find(".selected").removeClass("selected");

    //find the name of the selector that was clicked
    var selectedOptionName = $(this).data("option");

    //add the class "selected" to the tab and corresponding content
    $(this)
      .closest(".tabs")
      .find('[data-option="' + selectedOptionName + '"]')
      .addClass("selected");

    // google maps workaround
    //		google mymaps needs reloading when displayed as it does not work properly when iframe is loaded into a hidden area of html
    var $displayedTab = $(this)
      .closest(".tabs")
      .find('[data-option="' + selectedOptionName + '"]');

    $displayedTab.find(".iframeNeedsReloadingOnDisplay").each(function () {
      if (!$(this).attr("data-hasreloaded")) {
        //reload the iframe
        $(this).attr("src", $(this).attr("src"));

        //add marker so we don't reload again
        $(this).attr("data-hasreloaded", true);
      }
    });
  });

  // expandingFeaturedMSPs - works like tabs on desktop, looks different tho and all items displayed at all times on mobiles
  $(".selector").click(function () {
    //Remove class "active" from the tabs and the contents below
    $(this)
      .closest(".expandingFeaturedMSPs")
      .find(".selected")
      .removeClass("selected");

    //find the name of the selector that was clicked
    var selectedOptionName = $(this).data("option");

    //add the class "selected" to the tab and corresponding content
    $(this)
      .closest(".expandingFeaturedMSPs")
      .find('[data-option="' + selectedOptionName + '"]')
      .addClass("selected");
  });
});

function dismissAnnouncement() {
  var announcementBar = document.querySelector(".announcementBar");
  if (announcementBar) {
    announcementBar.style.display = "none";
  }
}
 $("#loadmoreButton").click(function () {
  var blocksToDisplay = $("#reviewsGrid").attr("data-blocks-to-display");
  var blocksToDisplay = +blocksToDisplay + 1;
  var scrollAmount = window.innerHeight / 2;

  $("#reviewsGrid").attr("data-blocks-to-display", blocksToDisplay);
  var currentPositionOfPage = window.scrollY;
  window.scrollBy({ top: scrollAmount, left: 0, behavior: "smooth" });
});
 $(document).ready(function () {
  $(".reviewContent").each(function () {
    var maxLength = 400;
    var myStr = $(this).text();
    if ($.trim(myStr).length > maxLength) {
      var newStr = myStr.substring(0, maxLength);
      var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
      $(this).empty().html(newStr);
      $(this).append(
        '<a href="javascript:void(0);" class="read-more"> Read more...</a>'
      );
      $(this).append('<span class="more-text">' + removedStr + "</span>");
    }
  });
  $(".read-more").click(function () {
    $(this).siblings(".more-text").contents().unwrap();
    $(this).remove();
  });
});
